<template>
    <div id="contendor-principal-creacionCedula">
        <div id="encabezados-tp">
            <h1>CREACIÓN DE CÉDULA PARA NOTIFICACIÓN</h1>
            <h3 style="color: var(--gris-pj)">Ingrese la información requerida para guardar la cédula</h3>
            <div class="hr-titulo"></div>
        </div>
        <div id="contendor-formulario-creacionDeCedula" class="padding-div-low">
            <div id="contenedor-creacionCedula" class="col-12">
                <ul class="nav nav-tabs" id="nav-tab-formulario-cedula" role="tablist">
                     <li class="nav-item">
                        <a class="nav-link active" id="busqueda-expediente-cedula-tab" data-toggle="tab" href="#busqueda-expediente-cedula" role="tab" aria-controls="busqueda-expediente-cedula" aria-selected="true"><i class="fas fa-archive"></i>&nbsp;Búsqueda de expediente</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link disabled" id="datos-generales-cedula-tab" data-toggle="tab" href="#informacion-cedula" role="tab" aria-controls="informacion-cedula" aria-selected="true"><i class="fas fa-edit"></i>&nbsp;Datos generales cédula</a>
                    </li>                    
                    <li class="nav-item">
                        <a class="nav-link disabled" id="asignar-acuerdos-tab" data-placement="top" data-toggle="tab" href="#asignar-acuerdos" role="tab"  aria-controls="asignar-acuerdos" aria-selected="true"><i class="fas fa-tasks"></i>&nbsp;Acuerdos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link disabled" id="llenar-plantilla-tab" data-placement="top" data-toggle="tab" href="#llenar-documento" role="tab"  aria-controls="llenar-documento" aria-selected="true"><i class="fas fa-file-alt"></i>&nbsp;Archivo de cédula</a>
                    </li>                    
                    <li class="nav-item" v-show="seNotificaEnJuzgado == 'true'">
                        <a class="nav-link disabled" id="resultado-cedula-tab" data-placement="top" data-toggle="tab" href="#resultado-cedula" role="tab"  aria-controls="resultado-cedula" aria-selected="true"><i class="fas fa-chalkboard-teacher"></i>&nbsp;Resultado de cédula</a>
                    </li>
                    <!--
                    <li class="nav-item">
                        <a class="nav-link disabled" id="crear-cedula-tab" data-placement="top" data-toggle="tab" href="#crear-cedula" role="tab"  aria-controls="crear-cedula" aria-selected="true"><i class="fas fa-file-upload"></i>&nbsp;Guardar Cédula</a>
                    </li>
                    -->
                </ul>
                <div class="nav_tab_formularios" id="pasos-creacion-cedula">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="busqueda-expediente-cedula" role="tabpanel" aria-labelledby="busqueda-expediente-cedula-tab">
                            <div style="display: flex;">
                                <div class="contenedor-color-negro col-8">                                    
                                    <FiltrosDeBusqueda 
                                        :mostrar="true"
                                        :ocultarParaDireccion="true"
                                        :catalogos="filtrosDeBusqueda" 
                                        :ejecutaLaFuncion="buscarExpediente" 
                                        :filtrosEstablecidos="filtrosEstablecidos"
                                        :buscar="!editar"
                                        v-on:cambiarTipoMateria="eventoCambioMateria"
                                        v-on:cambioDeArea="eventoCambioArea"
                                        v-on:cambioTipoDeDocumento = "cambioTipoDeDocumento"                                                                          
                                        :tituloDeBusqueda="'Filtros para búsqueda de expediente'"
                                        v-bind:key="filtrosKey"
                                        :ref="'filtroBusqueda_creacion'">
                                    </FiltrosDeBusqueda>                                    
                                </div>
                                <div class="contenedor-color-gris ml-4 w-100 d-flex align-items-center justify-content-center">
                                    <div>
                                        <div class="d-flex justify-content-center">
                                            <i v-if="busquedaExpediente" class="fas fa-archive" style="font-size: 16em; color: var(--verde-pj-100);"></i>
                                            <i v-if="expedienteEncontrado" class="fas fa-folder-open" style="font-size: 16em; color: var(--verde-pj-100);"></i>
                                        </div>
                                        <div id="estatus-busqueda-expediente" class="d-flex justify-content-center align-items-center">
                                            <div class="d-flex">
                                                <h4 v-if="busquedaExpediente"><!-- <i class="fas fa-search"></i> --> Busqueda de expediente ...</h4>
                                                <h4 v-if="expedienteEncontrado">Se encontró el expediente: <i class="fas fa-check-circle text-success" style="color: var(--verde-pj) !important;"></i></h4>
                                                <h4 v-if="!expedienteEncontrado && !busquedaExpediente">No se encontró el expediente: <i class="fas fa-times-circle text-danger" style="color: var(--verde-pj) !important;"></i></h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="expedienteEncontrado && !editar" style="display: flex; margin-top: 2em; justify-content: flex-end;">                                
                                <button type="button" id="btn-busqueda-expediente" class="btn btn-light" @click="avanzarDePestana($event)">Continuar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                            </div>
                            <div v-if="editar" style="display: flex; margin-top: 2em; justify-content: flex-end;">
                                <button type="button" id="btn-busqueda-expediente" class="btn btn-light" @click="continuarExpediente()">Continuar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="informacion-cedula" role="tabpanel" aria-labelledby="datos-generales-cedula-tab">
                            <h4 style="margin-bottom: 1em;"><strong>Paso 1: Ingrese los datos generales de la cédula</strong></h4>
                            <div class="">
                                <div class="card">
                                    <div class="card-header">
                                        <h5><strong>Persona a notificar&nbsp;&nbsp;[ <i class="fas fa-user"></i> ]</strong></h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="fila-formulario-horizontal">                                    
                                            <div class="col-6" style="padding: initial">
                                                <h6>Tipo de persona a notificar *</h6>                                     
                                                <select id="CDireccion-tipoPersona"  v-model="tipoDePersona" @change="cambioTipoDePersona($event)" class="form-control" v-bind:key="tipoDePersona">
                                                    <option value="-1">Seleccione a quien notificara</option>
                                                    <option value="1">Persona Física</option>
                                                    <option value="2">Persona Moral</option>
                                                    <option value="3">Parte</option>
                                                </select> 
                                            </div>
                                            <div :class="(seNotificaEnJuzgado == 'false' && esEstrado == 'false')? 'col-6' : 'col-3'">
                                                <h6>¿Se notifica en juzgado? *</h6>                                        
                                                <select id="seNotificaEnJuzgado_Select" class="form-control" v-model="seNotificaEnJuzgado" @change="seNotificaEnJuzgadoEvent()">                                            
                                                    <option value="false">No</option>
                                                    <option value="true">Si</option>                                            
                                                </select> 
                                            </div>
                                            <div class="col-3" v-show="(seNotificaEnJuzgado == 'true' || cedula.EsDeEstrado) && mostrarEstrado()">
                                                <h6>¿Es de estrado?</h6>
                                                <select id="esEstrado_Select" :class="[(esJuzgadoMixto) ? 'form-control deshabilitarSeccion' : 'form-control']" v-model="esEstrado" @change="esEstradoEvent()">                                            
                                                    <option value="false">No</option>
                                                    <option value="true">Si</option>                                            
                                                </select> 
                                            </div>
                                        </div>                                
                                        <div v-if="tipoDePersona != '-1'" id="campos-tipo-persona">
                                            <hr />                                    
                                            <div v-if="tipoDePersona === '1'" id="formulario-persona-fisica" style="margin-top: 2em;" :key="tipoDePersona">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h6>
                                                            Nombre *
                                                            <i v-if="mostrarErroresEnDatosGenerales && !personaFisica.nombre == ''" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                            <i v-if="mostrarErroresEnDatosGenerales && personaFisica.nombre == ''" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                        </h6>
                                                        <input class="form-control" type="text" placeholder="Ingrese el nombre de la persona" v-model="personaFisica.nombre" />
                                                    </div>
                                                    <div class="col-6">
                                                        <h6>
                                                            Apellido paterno
                                                            <i v-if="mostrarErroresEnDatosGenerales && (personaFisica.apellidoPaterno != '' || personaFisica.apellidoMaterno != '')" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                            <i v-if="mostrarErroresEnDatosGenerales && (personaFisica.apellidoPaterno == '' && personaFisica.apellidoMaterno == '')" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                        </h6>
                                                        <input class="form-control" type="text" placeholder="Ingrese el apellido paterno de la persona" v-model="personaFisica.apellidoPaterno" />
                                                    </div>
                                                    <div class="col-6">
                                                        <h6>
                                                            Apellido materno
                                                            <i v-if="mostrarErroresEnDatosGenerales && (personaFisica.apellidoPaterno != '' || personaFisica.apellidoMaterno != '')" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                            <i v-if="mostrarErroresEnDatosGenerales && (personaFisica.apellidoPaterno == '' && personaFisica.apellidoMaterno == '')" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                        </h6>
                                                        <input class="form-control" type="text" placeholder="Ingrese el apellido materno de la persona" v-model="personaFisica.apellidoMaterno" /> 
                                                    </div>
                                                    <div class="col-6">                                                
                                                        <h6>
                                                            Tipo Personalidad *
                                                            <i v-if="mostrarErroresEnDatosGenerales && parametros_TipoPersonalidad.tipoPersonalidadId > 0" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                            <i v-if="mostrarErroresEnDatosGenerales && parametros_TipoPersonalidad.tipoPersonalidadId < 0" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                        </h6>                                                
                                                        <C029TiposPersonalidades 
                                                            v-on:valorParaElPadre="cambioDeTipoDePersonalidad"
                                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                            :idDelInput="'empresa_TipoPersonalidad'" 
                                                            :parametros="parametros_TipoPersonalidad.parametros" 
                                                            :valorDefinido="parametros_TipoPersonalidad.tipoPersonalidadId" 
                                                            :key="parametros_TipoPersonalidad.key"></C029TiposPersonalidades>                                                
                                                    </div>
                                                </div>
                                            </div>                                    
                                            <div v-else-if="tipoDePersona === '2'" id="formulario-persona-Moral">                                         
                                                <div style="display: flex; align-items: center; justify-content: flex-end; margin-bottom: 1em;">
                                                    <h6 style="margin-right: 0.5em;">Asignar empresa con: </h6>
                                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                        <label :class="[conCatalogo ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="conCatalogo = true, conFormulario = false, parametros_Empresas.key ='conCatalogo'">
                                                            <input type="radio" name="options" id="radioConCatalogo" autocomplete="off"  checked>Catalogo
                                                        </label>
                                                        <label :class="[conFormulario ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="conCatalogo = false, conFormulario = true, parametros_Empresas.key ='sinCatalogo'/*, cargarDomiciliosDeExpedienteBase()*/">
                                                            <input type="radio" name="options" id="radioConFormulario" autocomplete="off" >Formulario
                                                        </label>
                                                    </div>
                                                </div>
                                                <div v-if="tipoDePersona == '2' && conCatalogo" id="registro-empresa-conCatalogo" class="row">
                                                    <div class="col-4">
                                                        <h6>
                                                            Empresa o establecimiento *
                                                            <i v-if="mostrarErroresEnDatosGenerales && parametros_Empresas.empresaId > 0" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                            <i v-if="mostrarErroresEnDatosGenerales && parametros_Empresas.empresaId < 0" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                        </h6>
                                                        <C007Empresas 
                                                            v-on:valorParaElPadre="eventoCambioDeEmpresa" 
                                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                            :idDelInput="'creacionDeCedula_Empresa'" 
                                                            :parametros="{ conRepresentantesLegales: true,conDomicilios: true,EsParaDireccion: false }" 
                                                            :valorDefinido="parametros_Empresas.empresaId" 
                                                            :key="parametros_Empresas.key"></C007Empresas>                                               
                                                    </div>
                                                    <div class="col-4">
                                                        <h6>
                                                            Representante legal                                                  
                                                        </h6> 
                                                        <select class="form-control" @change="cambiarRepresentanteLegal($event.target.value)" v-model="representanteLegal">
                                                            <option value="false">Quien acredite su legal representación</option>
                                                            <option value="true">Representante legal de empresa</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4" id="nuevoRepresentante_div" v-if="!representanteLegal" :key="'representante_nuevo' + representanteLegal">
                                                        <h6>Forma del representante legal</h6>
                                                        <input class="form-control" type="text" placeholder="Ingrese el representante legal" v-model="representanteUniversal" /> 
                                                    </div>
                                                    <div class="col-6" id="representantesEmpresa_div" v-if="parametros_Empresas.empresaId > 0 && representanteLegal" :key="'empresa' + representanteLegal">
                                                        <h6>
                                                            Representante legal
                                                            <i v-if="mostrarErroresEnDatosGenerales" class="fas fa-check-circle text-success font-size: 15px;"></i>                                                    
                                                        </h6>                                                
                                                        <CRepresentatesLegales 
                                                            v-on:valorParaElPadre="eventoCambioDeRepresentante" 
                                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                            :idDelInput="'creacionDeCedula_EmpresaRepresentanteLegal'" 
                                                            :valorDefinido="parametros_RepresentantesLegales.personaId" 
                                                            :textoOpcionesSingular="parametros_RepresentantesLegales.textoSelect" :elementosCatalogo="parametros_Empresas.representantesLegales" 
                                                            :key="parametros_RepresentantesLegales.key"></CRepresentatesLegales>
                                                    </div>  
                                                    <div class="col-6" v-if="parametros_Empresas.empresaId > 0 && representanteLegal" :key="representanteLegal">                                                
                                                        <h6>
                                                            Tipo Personalidad
                                                            <i v-if="mostrarErroresEnDatosGenerales" class="fas fa-check-circle text-success font-size: 15px;"></i>                                                    
                                                        </h6>                                                
                                                        <C029TiposPersonalidades 
                                                            v-on:valorParaElPadre="cambioDeTipoDePersonalidad"
                                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                            :idDelInput="'empresa_TipoPersonalidad'" 
                                                            :parametros="parametros_TipoPersonalidad.parametros" 
                                                            :valorDefinido="parametros_TipoPersonalidad.tipoPersonalidadId" 
                                                            :key="parametros_TipoPersonalidad.key"></C029TiposPersonalidades>                                                
                                                    </div>                                          
                                                    <div id="domiciliosEmpresa_div" class="col-12" v-if="parametros_Empresas.domicilios.length > 0" :key="parametros_Empresas.empresaId">
                                                        <h6>Domicilios</h6>                                                
                                                        <CTablaGenericaCedulas
                                                            :ref="'ref_domiciliosEmpresa'"
                                                            :idDelInput="'domiciliosEmpresa'"
                                                            :encabezadosColumnas="['#','Calle','Número', 'Fraccionamiento', 'Código Postal', 'Municipio', 'Referencias', '', '']"
                                                            :accionesEnTabla="{motrarAcciones: true,check: false, eliminar: false, editar: false,imprimir: false, ver: false, radio: true}"
                                                            v-on:accionRadioSeleccionado="evtDomicilioPrincipalEmpresa"
                                                            :listaDeCedulas="parametros_Empresas.domicilios"
                                                            :key="'K-TDOMICILIOS-EMPRESA' + contRenderTDomicliosEmpresa"></CTablaGenericaCedulas>
                                                    </div>                        
                                                </div>
                                                <div v-if="tipoDePersona == '2' && conFormulario">
                                                    <div id="formulario-registro">                                                
                                                        <CFormularioRegistroPersonaMoral                                                 
                                                        :ref="'registroAltaEmpresaForm'"
                                                        :idFormulario="'registroAltaEmpresaForm'"                                                
                                                        :implementarGuardado="false"
                                                        :personaMoralEditar = "parametros_personaMoral.persona"
                                                        :mostrarDomiciliosProp = "false"
                                                        :key="parametros_personaMoral.key"                                                
                                                        v-on:obtenerPersonaMoral="obtenerPersonaMoral"></CFormularioRegistroPersonaMoral>
                                                        
                                                    </div>
                                                    <!--<div id="formulario-registro">                                                
                                                        <CFormularioRegistroEmpresa
                                                        :creacionCedula= "true"                                                >
                                                        </CFormularioRegistroEmpresa>
                                                        <br>
                                                    </div>-->
                                                </div>                                        
                                            </div>
                                            <div v-else-if="tipoDePersona === '3'" id="contenedor-partes-expediente">
                                                <div id="titulo-tabla">
                                                    <h4>
                                                        Partes
                                                        <i v-if="mostrarErroresEnDatosGenerales && 
                                                            !((this.personaANotificar.PersonaId == undefined || this.personaANotificar.PersonaId <= 0) && 
                                                            (this.personaANotificar.PersonaIdDeReferencia == undefined || this.personaANotificar.PersonaIdDeReferencia <= 0))" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                        <i v-if="mostrarErroresEnDatosGenerales && 
                                                            ((this.personaANotificar.PersonaId == undefined || this.personaANotificar.PersonaId <= 0) && 
                                                            (this.personaANotificar.PersonaIdDeReferencia == undefined || this.personaANotificar.PersonaIdDeReferencia <= 0))" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                    </h4>
                                                </div>
                                                <table id="tablaPersonas" class="table table-dark contenido-listado" style="width: 100%; height: 100%" :key="'K-TPartes-' + contRenderTPartes">
                                                    <thead>
                                                        <tr>
                                                        <th class="encabezados-listado text-center" scope="col">Nombre</th>
                                                        <th class="encabezados-listado text-center" scope="col">Tipo Persona</th>                                                
                                                        <th class="encabezados-listado text-center" scope="col">Tipo Personalidad</th>                                                
                                                        <th class="encabezados-listado text-center" scope="col">
                                                            <div v-if="seNotificaEnJuzgado == 'true' && esEstrado == 'true'" class="form-inline justify-content-center"><input :id="'tabla-partes-seleccionarTodos'" type="checkbox" @change="seleccionarTodasPartes($event)" class="form-check-input" title="Seleccionar todo"></div>
                                                        </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(parte,index) in expediente.Personas" :key="'parte' + index">                                                  
                                                        <td v-for="(datosParte,index) in contenidoColumnasTablaPartes(parte)" class="text-center" :key="'columna' + index" v-html="datosParte"></td>
                                                        <td class="form-inline justify-content-center" v-if="seNotificaEnJuzgado == 'true' && esEstrado == 'true'">
                                                            <input :id="'tabla-partes' + '-check-' + parte.PersonaIdDeReferencia" name="parteANotificar" type="checkbox" class="form-check-input" @change="agregarParteSeleccionada($event, parte)">
                                                        </td>
                                                        <td class="text-center mx-auto" v-else>
                                                            <input :id="'tabla-partes' + '-check-' + parte.PersonaIdDeReferencia" name="parteANotificar" type="radio" class="form-check-input" @change="eventoParteSeleccionada($event, parte)">
                                                        </td>                                                  
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <nav id="paginacion-tabla-partes-creacionCedula">
                                                    <ul class="pagination justify-content-end">
                                                        <li class="page-item">
                                                            <button id="opcionInicio" type="button" class="page-link" v-if="pagina != 1" @click="cambioDePaginaConOpcion($event)"> Anterior </button>
                                                        </li>
                                                        <li :id="'tabla-partes-creacionCedula' + 'pagina'+ numeroDePagina" class="page-item" v-for="(numeroDePagina,index) in numeroDePaginas" :key="'pagina' + index">
                                                            <button type="button" class="page-link active" @click="cambioDePaginaConPuntero(numeroDePagina)"> {{numeroDePagina}} </button>
                                                        </li>
                                                        <li class="page-item">
                                                            <button id="opcionSiguiente" type="button" @click="cambioDePaginaConOpcion($event)" v-if="pagina < numeroDePaginas.length" class="page-link"> Siguiente </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                            <!-- borrar -->
                                            <!-- <div v-if="seNotificaEnJuzgado == 'true' && esEstrado == 'true' && personasANotificar.length > 0">
                                                    <h4>Personas a Notificar</h4>
                                                    <table id="personasANotificar_table" class="table table-dark contenido-listado" >
                                                        <thead>
                                                            <tr>
                                                            <th class="encabezados-listado text-center" scope="col">Nombre</th>
                                                            <th class="encabezados-listado text-center" scope="col">Tipo Persona</th>                                                
                                                            <th class="encabezados-listado text-center" scope="col">Tipo Personalidad</th>                                                
                                                            <th class="encabezados-listado text-center" scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(parte,index) in personasANotificar" :key="'parte' + index">                                                                                                         
                                                            <td v-for="(datosParte,index) in contenidoColumnasTablaPartes(parte)" class="text-center" :key="'columna' + index" v-html="datosParte"></td>
                                                            <td>
                                                                <button :id="'personasANotificar_table-eliminar-' + cedula.Folio" type="button" @click="eliminarPersonaANotificar($event, parte)" class="btn-sm btn-primary" title="Eliminar"><i class="fas fa-trash-alt"></i></button>
                                                            </td>                                                
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                                <!-- SECCION DOMICILIOS -->
                                <div v-show="(seNotificaEnJuzgado == 'false' && (tipoDePersona != '2' || (tipoDePersona == '2' && !conCatalogo))) || (tipoDePersona == '2' && conFormulario)" 
                                     style="margin-top: 2em;" class="mb-10 card" :key="'domicilio'+ seNotificaEnJuzgado">   
                                    <div class="card-header">
                                        <h5><strong>Domicilios&nbsp;&nbsp;[ <i class="fas fa-map-marked"></i> ]</strong>
                                            <i v-if="mostrarErroresEnDatosGenerales && 
                                                    ((this.listaDeDomicilios != undefined && this.listaDeDomicilios.length > 0) && (this.domicilioSeleccionado != null && this.domicilioSeleccionado != undefined))" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresEnDatosGenerales && 
                                                    ((this.listaDeDomicilios == undefined || this.listaDeDomicilios.length <= 0) || this.domicilioSeleccionado == null || this.domicilioSeleccionado == undefined)" class="fas fa-times-circle text-danger font-size: 25px;"></i>                                                    
                                        </h5>
                                    </div>                                     
                                    <div class="card-body">
                                        <div id="formulario-direccion-creacionCedula" class="form-group">                                                        
                                            <CFormularioDomicilio 
                                                :ref="'FormEmpresaDomicilio'"
                                                :idFormulario="'FormEmpresaDomicilio'" 
                                                :valorDefinidoFraccionamientos="parametros_Fraccionamientos.fraccionamientoId"
                                                :contadorRenderCatalogo="contadorRenderCatalogoP"
                                                :valorDefinidoMunicipios="valDefCM"
                                                v-on:domicilioPrincipal="evtObtenerDomicilioPrincipal"
                                                :contadorRenderCatalogoMunicipio="contRenderCM"
                                                :conSeleccionUnicaDeDomicilio="true"
                                                :herramientas="{ domicilioConPuntero: false, ubicarDomicilioEnMapa: true }"                                                                                                                                
                                                    v-on:obtenerContRenderC="contadorRenderCatalogoP = $event"
                                                    v-on:obtenerValorDefinidoCF="parametros_Fraccionamientos.fraccionamientoId = $event"
                                                    v-on:obtenerContRenderCM="contRenderCM = $event"
                                                    v-on:obtenerValorDefinidoCM="valDefCM = $event"
                                                    :conMensajeProcesoAgregar="false"
                                                    v-on:obtenerListadoDeDomicilios="obtenerListadoDeDomicilios"
                                                    :key="'CDomicilios-SINOJ-' + conRenderCDomicilios"></CFormularioDomicilio>                                            
                                        </div>     
                                    </div>                                                                               
                                </div>
                                <!-- SECCION DATOS GENERALES -->
                                <div class="card" style="margin-top: 2em;">
                                    <div class="card-header">
                                        <h5><strong>Datos generales&nbsp;&nbsp;[ <i class="fas fa-pen-square"></i> ]</strong></h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-3">
                                                <h6>
                                                    Área encargada *
                                                    <i v-if="mostrarErroresEnDatosGenerales && parametros_Jurisdicciones.jurisdiccionId > 0" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                    <i v-if="mostrarErroresEnDatosGenerales && parametros_Jurisdicciones.jurisdiccionId < 0" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                </h6>                                        
                                                <C003Jurisdicciones v-on:valorParaElPadre="cambioDeJurisdiccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'creacionDeCedula_Jurisdiccion'" :parametros="parametros_Jurisdicciones.parametros" :valorDefinido="parametros_Jurisdicciones.jurisdiccionId" :key="parametros_Jurisdicciones.key + RELACION_MUNICIPIOS_JURISDICCIONES.contRender"></C003Jurisdicciones>
                                            </div> 
                                            <div class="col-3">
                                                <h6>
                                                    Tipo de cédula *
                                                    <i v-if="mostrarErroresEnDatosGenerales && parametros_TiposCedula.tipoCedulaId > 0" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                    <i v-if="mostrarErroresEnDatosGenerales && parametros_TiposCedula.tipoCedulaId < 0" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                                                </h6>                                        
                                                <C002TiposCedula v-on:valorParaElPadre="cambioDeTipoCedula" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'creacionDeCedula_TiposCedula'" :parametros="parametros_TiposCedula.parametros" :valorDefinido="parametros_TiposCedula.tipoCedulaId" :key="parametros_TiposCedula.key"></C002TiposCedula>
                                            </div>             
                                            <div class="col-3">
                                                <h6>
                                                    ¿Es orden de protección?*                                           
                                                </h6>
                                                <select id="esOrdenDeProteccion_Select" class="form-control" v-model="esOrdenDeProteccion" @change="esOrdenDeProteccionEvent($event)">                                            
                                                    <option value="false">No</option>
                                                    <option value="true">Si</option>                                            
                                                </select>
                                            </div>                        
                                            <div class="col-3">
                                                <h6>Carácter de cédula *</h6>
                                                <div class="btn-group btn-group-toggle" data-toggle="buttons" style="width:100%">                                                                                   
                                                    <label :class="[esUrgente ? 'btn btn-secondary active' : 'btn btn-secondary']" style="width: 50%" @click="establecerUrgencia(true)">
                                                        <input type="radio" name="options" id="radioEsUrgente" autocomplete="off"  checked><i class="fas fa-shipping-fast"></i> &nbsp;&nbsp;Urgente
                                                    </label>
                                                    <label :class="[!esUrgente ? 'form-group btn btn-secondary active' : 'form-group btn btn-secondary']"  style="width:50%; overflow: hidden;" @click="establecerUrgencia(false)">
                                                        <input type="radio" name="options" id="radioNoEsUrgente" autocomplete="off" ><i class="fas fa-user-clock"></i>&nbsp;&nbsp;No urgente
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-3" v-if="mostrarCatalogoTipoDeAudiencias">
                                                <h6>Tipo de Audiencia</h6>                                        
                                                <C024TipoAudiencia v-on:valorParaElPadre="cambioTipoDeAudiencia" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'creacionDeCedula_TipoDeAudiencia'" :parametros="parametros_TipoAudiencia.parametros" :valorDefinido="cedula.TipoAudiencia != undefined && cedula.TipoAudiencia != null ? cedula.TipoAudiencia.TipoAudienciaId : -1" :key="parametros_TipoAudiencia.key"></C024TipoAudiencia>
                                            </div>
                                            <div class="col-3">
                                                <h6>Número de fojas</h6>
                                                <input type="text" class="form-control" title="Número de fojas"  placeholder="0" v-model="cedula.NumeroDeFojas"/>
                                            </div>
                                            <div class="col-3">
                                                <h6>Días de término</h6>
                                                <input type="text" class="form-control" title="Días de término" placeholder="0" v-model="cedula.DiasDeTermino" />
                                            </div>
                                            <!-- NUMERO ORDEN DE PROTECCION -->
                                            <div v-if="habilitarOrdenProteccion" class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                                <div class="form-group">
                                                    <h6>numero de orden de protección</h6>
                                                    <input type="text" class="form-control" title="# orden proteccion"  placeholder="0" v-model="numeroOrdenProteccion"/>
                                                </div>
                                            </div>
                                            <div class="col-3" v-if="mostrarInputsParaSentencias">
                                                <h6>Fecha de dictado de sentencia</h6>
                                                <input type="date" class="form-control" v-model="cedula.FechaDeDictadoDeSentencia"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div style="display: flex; margin-top: 2em; justify-content: flex-end;">
                                <button type="button" id="btn-datos-generales" class="btn btn-light" @click="avanzarDePestana($event)">Guardar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="llenar-documento" role="tabpanel" aria-labelledby="llenar-plantilla-tab">
                            <h4><strong>Paso 3: Suba el documento de la cédula</strong></h4>                                                     
                            <h6 style="margin-bottom: 1em; color: black;">Descargue el documento de la cédula, realice las modificaciones correspondientes y posteriormente suba el documento final.</h6>                                                     
                            <div style="width: 100%; margin-top: 2.5em;">
                                <CSubidorDeArchivos 
                                :parametros = "parametros_SubidorDeArchivos" 
                                v-on:obtenerArchivo="obtenerArchivo" 
                                v-on:crearArchivo="crearArchivodeCedula" 
                                :anexosDeExpediente="expediente.Anexos"
                                :key="parametros_SubidorDeArchivos.key + contRenderSubidorDocumento"
                                :ref="'subidorArchivoCedula'"></CSubidorDeArchivos>
                            </div>                            
                             <!-- <div style="margin-top: 2em;" class="text-right">
                                <button type="button" id="btn-datos-plantilla" class="btn btn-primary" @click="avanzarDePestana($event)">Guardar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                             </div> -->
                             <div style="margin-top: 2em;" class="text-right" v-if="this.seNotificaEnJuzgado == 'true'">
                                <button type="button" id="btn-guardar-cedula" class="btn btn-light" @click="avanzarDePestana($event)"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                            <div style="margin-top: 2em;" class="text-right" v-else>
                                <button type="button" id="btn-guardar-cedula" class="btn btn-light" @click="avanzarDePestana($event)"><i class="fas fa-save"></i>&nbsp;&nbsp;Finalizar</button>
                            </div>

                        </div>
                        <div class="tab-pane fade" id="asignar-acuerdos" role="tabpanel" aria-labelledby="asignar-acuerdos-tab">
                            <h4 style="margin-bottom: 1em;"><strong>Paso 2: Seleccione los acuerdos que corresponden a la cédula</strong></h4>
                            <!-- SECCION TABLA DE ACUERFOS -->
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="text-center"><strong>Lista de acuerdos</strong></h5>
                                </div>
                                <div class="card-body">
                                    <CTablaGenericaCedulas style="padding: 0.5em 1em 0em 1em;"
                                        :idDelInput="'tabla_AcuerdosCreacionDeCedula'"
                                        :encabezadosColumnas=" ['Folio', 'Tipo de documento','Extracto', 'Fecha de publicación', 'Ver']"
                                        :alineacionesColumnas ="['text-center', 'text-left', 'text-center']"
                                        :accionesEnTabla="{ check: true, motrarAcciones: true, ver: true, eliminar: false }"
                                        :listaDeCedulas="parametros_listaDeAcuerdos.listaDeAcuerdos"
                                        :listaCedulasSeleccionadas="parametros_listaDeAcuerdos.listaDeAcuerdosSelect"                                
                                        v-on:accionesFuncionDeVer= "verAcuerdo"
                                        v-on:elementoSeleccionado= "acuerdosSeleccionado"
                                        :key="parametros_listaDeAcuerdos.key"></CTablaGenericaCedulas>
                                </div>                                
                            </div>
                            <br/>
                            <div id="acuerdosSeleccionados_div" v-if="parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.length > 0" 
                                class="card">
                                <div class="card-header">
                                    <h5><strong>Acuerdos seleccionados</strong></h5>                                
                                    <h6>En caso de que algún acuerdo fije audiencia favor de indicar la fecha.</h6>
                                </div>
                                <div class="card-body">
                                    <div style="display: flex; align-items: center; justify-content: center;">
                                        <table id="lista-acuerdos-seleccionados" class="col-12">
                                            <thead>
                                                <th class="encabezados-listado text-center">Folio</th>
                                                <th class="encabezados-listado text-center">Extracto</th>
                                                <th class="encabezados-listado text-center">Fecha de publicación</th>
                                                <th class="encabezados-listado text-center" v-if="tipoDocumentoId == enumeraciones.pj.tiposDocumento.Exhorto">Fecha de emisión</th>
                                                <th class="encabezados-listado text-center" v-if="tipoDocumentoId == enumeraciones.pj.tiposDocumento.Exhorto">Fechas de emisión</th>
                                                <th class="encabezados-listado text-center">Fecha de audiencia</th>
                                                <th class="encabezados-listado text-center">Acuerdo principal</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(acuerdoSelect, index) in parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados" :key="'acuerdo'+ index">                                                                                        
                                                    <td class="text-center">{{acuerdoSelect.AcuerdoIdReferencia}}</td>   
                                                    <td class="text-left" v-if="acuerdoSelect.Extracto.length > 100">{{acuerdoSelect.Extracto.substring(0,100) + " ..."}}</td> 
                                                    <td class="text-left" v-else>{{acuerdoSelect.Extracto}}</td>   
                                                    <!--<td class="text-left">{{acuerdoSelect.Extracto}}</td>-->
                                                    <td class="text-center" v-html="obtenFechaConFormato(acuerdoSelect.FechaDePublicacion)">{{acuerdoSelect.FechaDePublicacion}}</td>                                               
                                                    <td class="text-center" v-if="tipoDocumentoId == enumeraciones.pj.tiposDocumento.Exhorto">
                                                        <div class="input-group">                                                
                                                        <!--<Datepicker 
                                                        :format="'dd-MM-yyyy'" 
                                                        v-model="acuerdoSelect.FechaDeEmision" 
                                                        :bootstrap-styling="true"
                                                        :calendar-button="true"
                                                        calendar-button-icon="far fa-calendar-alt"  
                                                        :class="{'texto-negro': true, 'margin': '0px'}" name="fecha" 
                                                        :language="languaje">                                                          
                                                        </Datepicker>   -->
                                                        <input type="datetime-local" class="form-control" v-model="acuerdoSelect.FechaDeEmision" >                                            
                                                        <button type="button" id="btn-datos-agregarfechaemision" class="btn btn-sm btn-primary" @click="agregarFechaDeEmision(acuerdoSelect)"><span class="fas fa-plus"></span></button>                                                                                                
                                                        </div>
                                                    </td>     
                                                    <td class="text-center" v-if="tipoDocumentoId == enumeraciones.pj.tiposDocumento.Exhorto">
                                                        <ul v-if="FechasDeEmision.length >0 && FechasDeEmision.filter(fecha => fecha.Acuerdo.AcuerdoIdReferencia == acuerdoSelect.AcuerdoIdReferencia).length > 0">
                                                            <li v-for="(fecha, index) in FechasDeEmision.filter(fecha => fecha.Acuerdo.AcuerdoIdReferencia == acuerdoSelect.AcuerdoIdReferencia)" :key="'fechaEmision'+index"><span v-html="formatoFecha(fecha.Fecha)"></span>&nbsp;&nbsp;<span class="fas fa-trash" @click="eliminarFechaEmision(fecha)"></span></li>
                                                        </ul>                                                
                                                    </td>
                                                    <td class="text-center">
                                                        <!-- <input type="date" class="form-control" v-model="acuerdoSelect.FechaDeAudiencia" style="width: 60%;"/>--> 
                                                        <div style="display: flex; align-items: center; justify-content: center;">
                                                            <input type="datetime-local" class="form-control" v-model="acuerdoSelect.FechaDeAudiencia" :min="new Date().toISOString().slice(0,19)">
                                                        </div>
                                                    </td>                                       
                                                    <td class="text-center mx-auto">   
                                                        <div style="display: flex; align-items: center; justify-content: center;">
                                                            <input type="radio" v-model="parametros_listaDeAcuerdos.acuerdoPrincipal" :value="acuerdoSelect.AcuerdoIdReferencia" class="form-check-input" name="acuerdoPrincipal" @click="cambioAcuerdoPrincipal(acuerdoSelect)">
                                                        </div>                                             
                                                    </td>                                            
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> 
                                </div>                              
                            </div>
                            <br/>
                            <div class="card">
                                <div class="card-header">
                                     <h5><strong>Observaciones&nbsp;&nbsp;[ <i class="fas fa-sticky-note"></i> ]</strong></h5>
                                </div>
                                <div class="card-body">
                                    <h6>Ingresa las observaciones para la cédula&nbsp;&nbsp;&nbsp;[ <i class="fas fa-marker" style="font-size: 0.7em;"></i> ]</h6>
                                    <textarea class="form-control" v-model="cedula.Observaciones"></textarea>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 2em;">
                                <div class="contenedor-color-negro-info" style="display: flex; padding: 1em; align-items: center;">
                                    <h6 style="margin-right: 0.3em; color: black;"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;#Acuerdos Seleccionados:</h6><label style="text-decoration: underline; color: black;">{{parametros_listaDeAcuerdos.numeroDeAcuerdosSeleccionados}}</label>
                                </div>
                                <div><button type="button" id="btn-datos-acuerdos" class="btn btn-light" @click="avanzarDePestana($event)">Guardar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button></div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="resultado-cedula" role="tabpanel" aria-labelledby="resultado-cedula-tab">
                            <h4 style="margin-bottom: 1em;"><strong>Paso 4: Indique el resultado de la cédula</strong></h4>
                            <div class="card">
                                <div class="card-header">
                                    <h5><strong>Estatus del resultado</strong></h5>
                                </div>
                                <div class="card-body">
                                    <div class="row col-12" style="padding-right: 0px;">
                                        <div class="col-6">
                                            <h6>Resultado&nbsp;&nbsp;[*]</h6>                                
                                            <input disabled="disabled" type="text" id="cedula_area" class="form-control" value ="Finalizada"/>
                                        </div>
                                        <div class="col-6" style="padding-right: 0px;">
                                            <h6>Observaciones&nbsp;&nbsp;[ <i class="fas fa-marker" style="font-size:0.7em;"></i> ]</h6>
                                            <textarea class="form-control" v-model="observacionesResultadoCedula"></textarea>
                                        </div>                          
                                    </div> 
                                </div>
                            </div>
                            <div  style="margin-top: 3em;">
                                <CSubidorDeArchivos 
                                :parametros = "parametros_SubidorDeArchivosResultado" 
                                v-on:obtenerArchivo="obtenerArchivoResultado"
                                v-on:crearArchivo="crearArchivodeResultado"  
                                :key="parametros_SubidorDeArchivosResultado.key" :ref="'subidorResultado'"></CSubidorDeArchivos>
                            </div>                         
                            <div style="margin-top: 2em;" class="text-right">
                                <button type="button" id="btn-resultado-cedula" class="btn btn-success" @click="avanzarDePestana($event)">Finalizar&nbsp;&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                             </div>
                        </div>
                        <div class="tab-pane fade" id="crear-cedula" role="tabpanel" aria-labelledby="crear-cedula-tab">
                            <h4 v-if="seNotificaEnJuzgado == 'false'" style="margin-bottom: 1em;">Paso 4: Revise la información, si es correcta favor de guardar la cédula</h4>
                            <h4 v-else style="margin-bottom: 1em;">Paso 5: Revise la información, si es correcta favor de guardar la cédula</h4>
                            <!-- ASIGNACION MANUAL DE NOTIFICADOR -->
                            <div v-if="esJuzgadoMixto" class="contenedor-color-negro row no-gutters mb-4">
                                <div class="col-6">
                                    <div class="form-inline">
                                        <h6 class="mr-2">Asignar a notificador de manera manual: </h6>
                                        <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                            <label :class="[asignacionManualJuzgadosMixtos.aplicar ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="asignacionManualJuzgadosMixtos.aplicar = true">
                                                <input type="radio" name="options" id="asignacionManual" autocomplete="off"  checked>SI
                                            </label>
                                            <label :class="[!asignacionManualJuzgadosMixtos.aplicar ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="asignacionManualJuzgadosMixtos.aplicar = false">
                                                <input type="radio" name="options" id="asignacionNoManual" autocomplete="off" >NO
                                            </label>
                                        </div>
                                    </div>
                                    <div v-if="asignacionManualJuzgadosMixtos.aplicar" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-3 pb-0">
                                        <C020Notificadores
                                            class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoNotificador" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="asignacionManualJuzgadosMixtos.catalogoNotificadores.ID" 
                                            :parametros="asignacionManualJuzgadosMixtos.catalogoNotificadores.parametros" 
                                            :valorDefinido="asignacionManualJuzgadosMixtos.catalogoNotificadores.valorDefinido" 
                                            :key="asignacionManualJuzgadosMixtos.catalogoNotificadores.KEY + asignacionManualJuzgadosMixtos.catalogoNotificadores.contRender"
                                            :filtrarPorJurisdiccion="true"></C020Notificadores>
                                    </div>
                                </div>
                                <div v-show="asignacionManualJuzgadosMixtos.aplicar" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pl-0 align-self-center">
                                    <div class="form-inline justify-content-center align-items-center asignacion-manual-estatus">
                                        <i style="font-size: 4.3em;" class="fas fa-address-card"></i>
                                        <i v-if="asignacionManualJuzgadosMixtos.catalogoNotificadores.valorDefinido > 0" style="font-size: 1.6em; position: absolute; left: 90%; top: 60%;" class="fas fa-check-circle text-success"></i>
                                        <i v-if="asignacionManualJuzgadosMixtos.catalogoNotificadores.valorDefinido < 0" style="font-size: 1.6em; position: absolute; left: 90%; top: 60%;" class="fas fa-times-circle text-danger"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- FIN ASIGNACION MANUAL DE NOTIFICADOR -->
                            <div class="contenedor-color-negro-info">
                                <h5><i class="fas fa-file-alt"></i>&nbsp;Información de la cédula con Folio: {{ cedula.CedulaId }} </h5>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                                <div class="col-12" style="padding: 0px;">
                                    <h6>Expediente</h6>
                                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                                </div>
                                <div class="row">                                    
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_area">Área</h6>
                                        <input disabled="disabled" v-model="cedula.Expediente.Juzgado.Nombre" type="text" id="cedula_area" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_tipoDocumento">Tipo de documento</h6>
                                        <input disabled="disabled" v-model="cedula.Expediente.TipoDocumento.Nombre" type="text" id="cedula_tipoDocumento" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_numeroDocumento">Consecutivo</h6>
                                        <input disabled="disabled" v-model="cedula.Expediente.NumeroDeDocumento" type="text" id="cedula_numeroDocumento" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group" v-if="cedula.Expediente.TipoDocumento.TipoDocumentoId == 2 || cedula.Expediente.TipoDocumento.TipoDocumentoId == 10">
                                        <h6 for="cedula_numeroDocumento">Número</h6>
                                        <input disabled="disabled" v-model="cedula.Expediente.Consecutivo" type="text" id="cedula_numeroDocumento" class="form-control"/>
                                    </div>
                                    <div class="col-12" v-if="parametros_listaDeAnexos.listaDeAnexos.length > 0">
                                        <h6>Anexos</h6>
                                        <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                                        <CTablaGenericaCedulas style="margin-top: 1em; "
                                            :idDelInput="'tabla_AnexosCreacionDeCedula'"
                                            :encabezadosColumnas=" ['Cantidad','Nombre']"
                                            :accionesEnTabla="{ motrarAcciones: false }"
                                            :listaDeCedulas="parametros_listaDeAnexos.listaDeAnexos"   
                                            :limitePaginacion = "2"                                                                         
                                            :key="parametros_listaDeAnexos.key">
                                        </CTablaGenericaCedulas>
                                    </div>   
                                    <div class="col-12">
                                        <h6>Cédula</h6>
                                        <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>                                                             
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_tipoCedula">Tipo de cédula</h6>                                        
                                        <input disabled="disabled" v-model="cedula.TipoCedula.Nombre" type="text" id="cedula_tipoCedula" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_jurisdiccion">Área encargada</h6>                                        
                                        <input disabled="disabled" :value="cedula.Jurisdiccion.Area.Nombre" v-on:input="cedula.Jurisdiccion.Area.Nombre = $event.target.value.toUpper()" type="text" id="cedula_jurisdiccion" class="form-control"/>
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">Urgente</h6>                                                                               
                                        <input disabled="disabled" v-if="esUrgente" value="Si" type="text" class="form-control"/>
                                        <input disabled="disabled" v-else value="No" type="text" class="form-control"/>                                        
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">¿Se notifica en juzgado?</h6>                                                                               
                                        <input disabled="disabled" v-if="seNotificaEnJuzgado == 'true'" value="Si" type="text" class="form-control"/>
                                        <input disabled="disabled" v-else value="No" type="text" class="form-control"/>                                        
                                    </div>
                                    <div class="col-4 form-group" v-show="seNotificaEnJuzgado == 'true'">
                                        <h6 for="cedula_urgente">¿Es de estrado?</h6>                                                                               
                                        <input disabled="disabled" v-if="esEstrado" value="Si" type="text" class="form-control"/>
                                        <input disabled="disabled" v-else value="No" type="text" class="form-control"/>                                        
                                    </div>
                                    <div class="col-4 form-group">
                                        <h6 for="cedula_urgente">¿Es orden de protección?</h6>                                                                               
                                        <input disabled="disabled" v-if="esOrdenDeProteccion" value="Si" type="text" class="form-control"/>
                                        <input disabled="disabled" v-else value="No" type="text" class="form-control"/>                                        
                                    </div>
                                    <div class="col-12 form-group">
                                        <h6 for="cedula_acuerdos">Acuerdos</h6>  
                                        <hr style="height:1px;border:none;color:#FFF;background-color:#FFF;"/>
                                        <div v-for="(acuerdo, index) in cedula.Acuerdos" v-bind:key="acuerdo.AcuerdoId + index" class="row form-group">                                            
                                            <div class="col-4 form-group">
                                                <h6 for="cedula_urgente">Folio</h6>
                                                <input disabled="disabled" v-model="acuerdo.AcuerdoIdReferencia" type="text" class="form-control"/>
                                            </div>
                                            <div  :class="acuerdo.FechaDeEmision != null && acuerdo.FechaDeEmision != 'Invalid date' ? 'col-2 form-group' : 'col-4 form-group'">
                                                <h6 for="cedula_urgente">Fecha de publicación</h6>                                                
                                                <input disabled="disabled" :key="'fechaAcuerdo'" v-model="acuerdo.FechaDePublicacion" v-html="formatoFechaAcuerdo(acuerdo)" type="text" class="form-control"/>
                                            </div>
                                            <div :class="acuerdo.FechaDeEmision != null && acuerdo.FechaDeEmision != 'Invalid date' ? 'col-2 form-group' : 'col-4 form-group'" v-if="acuerdo.FechaDeEmision != null && acuerdo.FechaDeEmision != 'Invalid date'">
                                                <h6 for="cedula_urgente">Fecha de emisión</h6>                                                
                                                <input disabled="disabled" :key="'fechaEmisionAcuerdo'" v-model="acuerdo.FechaDeEmision" type="text" class="form-control"/>
                                            </div>                                            
                                            <div class="col-4 form-group">
                                                <h6 for="cedula_urgente">Es principal</h6>
                                                <input disabled="disabled" v-if="acuerdo.EsPrincipal" value="Si" type="text" class="form-control" />
                                                <input disabled="disabled" v-else value="No" type="text" class="form-control" />                                                
                                            </div>                                                                                    
                                        </div>                                      
                                    </div>
                                    <div class="col-12 form-group">
                                        <h6 for="cedula_acuerdos">Observaciones</h6>
                                        <input disabled="disabled" :value="cedula.Observaciones" type="text" class="form-control" />
                                    </div>
                                    <div class="col-12 form-group">
                                        <h6 for="cedula_acuerdos">Archivo de cédula</h6>
                                        <input  disabled="disabled" :key="nombreArchivoDeCedula" v-model="nombreArchivoDeCedula" v-html="obtenerNombreArchivoDeCedula()" type="text" id="cedula_archivo" class="form-control"/>
                                    </div>   
                                    <div class="row col-12 form-group" v-if="seNotificaEnJuzgado == 'true'" style="padding-right: 0px;"> 
                                        <div class="col-12">
                                            <h6 for="cedula_acuerdos">Resultado</h6>  
                                            <hr style="height:1px;border:none;color:#FFF;background-color:#FFF;"/>
                                        </div>
                                        <div class="col-6 form-group">
                                            <h6>Estatus</h6>
                                            <input disabled="disabled" value="Realizada" type="text" class="form-control" />
                                        </div>
                                        <div class="col-6 form-group" style="padding-right: 0px;">
                                            <h6>Observaciones</h6>
                                            <input disabled="disabled" :value="observacionesResultadoCedula" type="text" class="form-control" />
                                        </div>
                                        <div class="col-12" style="padding-right: 0px;" v-show="nombreArchivoDeResultado != undefined && nombreArchivoDeResultado != null">
                                            <h6>Archivo de resultado</h6>
                                            <input  disabled="disabled" :key="nombreArchivoDeResultado" v-model="nombreArchivoDeResultado" v-html="obtenerNombreArchivoDeResultado()" type="text" id="cedulaResultado_archivo" class="form-control"/>
                                        </div>
                                    </div>                                 
                                </div>
                            </div>                            
                            <div style="margin-top: 2em;" class="text-right">
                                <button type="button" id="btn-guardar-cedula" class="btn btn-success" @click="avanzarDePestana($event)"><i class="fas fa-save"></i>&nbsp;&nbsp;Finalizar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Acuerdo</h5>
                        <button id="btn-cerrar-visor" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div>
                                <PDFDocument v-if="parametros_acuerdoSeleccionado.acuerdo != null" :url="parametros_acuerdoSeleccionado.acuerdo.Ruta" :height="'650px'" :key="parametros_acuerdoSeleccionado.key"/>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="abandondarPagina_div">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Mensaje del sistema</h5>                    
                </div>
                <div class="modal-body">
                    <p>La cédula no se ha terminado, si sale de la vista se perderán los cambios. ¿Desea salir?</p>                                        
                </div>  
                <div class="modal-footer">                                                  
                    <button class="btn btn-primary" @click="dirigir = ''" data-dismiss="modal"><i class="fas fa-times"></i>&nbsp;Cancelar</button>                        
                    <button class="btn btn-primary" @click="cancelarCedula()"><i class="fas fa-check"></i>&nbsp;Salir</button>                        
                </div>
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo-dom">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>¿Deseas guardar el domicilio para futuras notificaciones al expediente?</h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="iniciarProcesoGuardarDomicilioAExpediente"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="accionesModal({ id: 'modal-informativo-dom', accion: 'hide' })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION  -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo-expediente">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>¿Deseas seguir notificando a este expediente?</h6>
                        </div>
                        <div class="form-group">
                            <div id="opciones-seguir-notificando" class="alert alert-dark" role="alert">
                                <i class="fas fa-question-circle">&nbsp;&nbsp;Opciones para conservar la información en el formulario</i>
                                <hr style="margin-top: 0.3em">
                                <i @click="opcionesSeguirNotificando.conDomicilios = !opcionesSeguirNotificando.conDomicilios" 
                                    :class="(!opcionesSeguirNotificando.conDomicilios) ? 'far fa-square texto-filtros' : 'fas fa-check-square texto-filtros'"
                                    style="cursor: pointer;"></i>&nbsp;&nbsp;Conservar Información de domicilio
                                <br>
                                <i @click="opcionesSeguirNotificando.conAcuerdos = !opcionesSeguirNotificando.conAcuerdos" 
                                    :class="(!opcionesSeguirNotificando.conAcuerdos) ? 'far fa-square texto-filtros' : 'fas fa-check-square texto-filtros'"
                                    style="cursor: pointer;"></i>&nbsp;&nbsp;Conservar Información de acuerdos
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="evtSeguirNotificandoAlMismoExpediente"><i class="fas fa-check"></i>&nbsp;&nbsp;Si</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="evtNoSeguirNotificando"><i class="fas fa-times"></i>&nbsp;&nbsp;No</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>  
  import sistemas from '@/../static/js/sistemas'  
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'
  import VueMask from 'v-mask'
  import { markup } from '../Creacion/datosEditor.js'
  import funcion from '../../../../../static/js/api/comun/funcion/funcion.js'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import Router from '@/router/index'
  import Datepicker from 'vuejs-datepicker'  
  import { campoEsValido, manipularVisualizacionModal } from "../../Comun/Funciones/validaciones.js"
  //import moment from 'moment'


  Vue.use(VueMask);

  export default {
    components: {
       comun,
       Router,
       Datepicker,
       FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,       
       CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,       
       CFormularioRegistroEmpresa: sistemas.SINOJ.CFormularioRegistroEmpresa,       
       CFormularioRegistroPersonaMoral: sistemas.SINOJ.CFormularioRegistroPersonaMoral,
       CRepresentatesLegales: sistemas.SINOJ.CCatalogoGenerico,
       CFormularioDomicilio: sistemas.SINOJ.CFormularioDomicilio, 
       C002TiposCedula: catalogos.SINOJ.C002TiposCedula,
       C003Jurisdicciones: catalogos.SINOJ.C003Jurisdicciones,       
       C007Empresas: catalogos.SINOJ.C007Empresas,
       C009TiposPlantilla: catalogos.SINOJ.C009TiposPlantilla,    
       C029TiposPersonalidades: catalogos.PJ.C029TipoPersonalidad,
       C024TipoAudiencia: catalogos.PJ.C024TipoAudiencia,
       CSubidorDeArchivos: sistemas.SINOJ.CSubidorDeArchivos,
       C020Notificadores: catalogos.SINOJ.C020Notificadores,       
       PDFDocument       
    },
    data: () => {
        return {    
            numeroOrdenProteccion: null, 
            habilitarOrdenProteccion: false,
            TIPOS_CEDULAS: {
                // AUDIENCIA CONFESIONAL = 1, AUDIENCIAS = 10
                AUDIENCIAS: [1,10],
                SENTENCIAS: [11]
            },
            contRenderTDomicliosEmpresa: 0,
            contRenderSubidorDocumento: 0,
            conRenderCDomicilios: 0,
            contRenderTPartes: 0,
            opcionesSeguirNotificando: {
                conDomicilios: true,
                conAcuerdos: true,
                activado: false
            },
            auxpersonaANotificar: {},  
            manipularVisualizacionModal,    
            pruebaFecha: new Date(Date.now() - 8640000),
            enumeraciones,                                                                                   
            mostrarErroresEnDatosGenerales: false, 
            parametros_Fraccionamientos: {
                key: "",
                fraccionamientoId: -1,
                parametros: {}
            },          
            parametros_Jurisdicciones: {
                key: "",
                jurisdiccionId: -1,
                parametros: {
                    conAreasDeJurisdiccion: true
                }
            },
            parametros_TiposCedula: {
                key: "",
                tipoCedulaId: -1,
                parametros: {}
            },            
            parametros_Empresas: {
                key: "",
                empresaId: -1,
                representantesLegales:[], 
                empresas: [],
                domicilios: [],               
                parametros: {
                    conRepresentantesLegales: true,
                    conDomicilios: true,
                    EsParaDireccion: false
                },
                objetoBD: null
            },
            parametros_TipoPersonalidad: {
                key: "",
                tipoPersonalidadId: -1,
                parametros: {}
            },
            parametros_RepresentantesLegales:{
                key: "",
                personaId: -1,
                textoSelect: 'empresa',
                listadoRepresentantesLegales: [],
                representantesLegales: [],
                parametros: {}
            },
            parametros_SubidorDeArchivos:{
                extensionDocumento: ['doc', 'docx', 'pdf'],
                height: '495px',
                areaId: null,
                key: 'K-CSubidorArchivo'
            },
            parametros_SubidorDeArchivosResultado: {
                extensionDocumento: ['doc', 'docx', 'pdf'],
                height: '495px',
                areaId: null,
                key: ''
            },
            parametros_personaMoral:{
                persona: Object,
                key: ""
            },
            parametros_TipoAudiencia: {
                TipoAudienciaId: -1,
                parametros: {
                    soloEquitas: true
                },
                key: ''
            },
            filtrosDeBusqueda: [
                { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtro-materia-creacionCedula' },
                { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtro-area-creacionCedula' },
                { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtro-tipoDocumento-creacionCedula' },
                { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtro-numeroExpediente-creacionCedula' },
                { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtro-numeroExtra-creacionCedula' }
            ],
            filtrosEstablecidos: {}, 
            filtrosKey: "key",           
            busquedaExpediente: true,
            expedienteEncontrado: false,            
            expediente:{
              Personas: [],
              Acuerdos: []
            },
            parametros_listaDeAcuerdos: {
                key: 'K-LACUERDOS-',
                listaDeAcuerdos: [],
                listaDeAcuerdosSelect: [],
                numeroDeAcuerdosSeleccionados: 0,
                listaDeAcuerdosSeleccionados: [],
                acuerdoPrincipal: undefined,
                acuerdosDeAudiencia: [],
            },
            parametros_listaDeAnexos: {
                key: '',
                listaDeAnexos: [],
            },
            tipoDePersona: '3',
            parteANotificar: {},
            pagina: 1,
            numeroDePaginas: [],
            partesAmostrarPorPagina: 5,  
            personaFisica :{
                nombre: '',
                apellidoPaterno: '',
                apellidoMaterno: ''
            },          
            personaANotificar: {
                Domicilios: []
            },         
            listaDeDomicilios: [],   
            jurisdicciones: [],  
            conFormulario: false,
            conCatalogo: true,           
            esUrgente: false,
            esPrincipal: false,
            cedula:{
                Expediente: {
                    Juzgado: {
                        Nombre: null
                    },
                    TipoDocumento: {
                        Nombre: null
                    },
                    NumeroDeDocumento: null
                },
                TipoCedula: {
                    Nombre: null
                },
                Jurisdiccion: {
                    Area: { Nombre: null }
                },
                Urgente: null,
                Acuerdos: [],
                ArchivoRuta: null,
                Resultado: {
                    ArchivoResultado_Ruta: "",
                },
                TipoDeAudiencia:{
                    TipoDeAudienciaId: -1
                },
                NumeroDeFojas: null,
                DiasDeTermino: null,
                FechaDeDictadoDeSentencia: new Date(),
                Observaciones: "",
                Comentarios: ""
            },
            archivoCedula: null,
            archivoResultadoCedula: null,
            observacionesResultadoCedula: null,
            nombreArchivoDeCedula: null,
            nombreArchivoDeResultado: null,
            parametros_acuerdoSeleccionado: {
                acuerdo: null,
                key: ''
            },            
            editar: false,
            contadorRenderCatalogoP: 0,
            contRenderCM: 0,            
            valDefCM: -1,                                                                                                    
            dirigir: '',
            disabledDates: {      
                to: new Date()                    
            },
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            representanteLegal: false,
            representanteUniversal: '',
            tipoDocumentoId: Number,
            seNotificaEnJuzgado: 'false', 
            esEstrado: false,
            esOrdenDeProteccion: false,
            creacionArchivo_index: 0, 
            creacionArchivoResultado_index: 0,   
            personasANotificar: [],            
            FechasDeEmision: [],
            contadorFechasEmision: 0,
            areaUsuarioJuzgado: null,
            asignacionManualJuzgadosMixtos: {
                aplicar: false,
                catalogoNotificadores: {
                    ID: 'CTipoNotificadorVCC',
                    KEY: 'KTipoNotificadorVCC',
                    parametros: { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false },
                    valorDefinido: -1,
                    seleccionado: null,
                    contRender: 0
                }
            },
            listaDeMixtos: [17,18,24,29,69,70,71,72,73,74,75,76,77],
            expedienteBase: {
                objeto: null,
                domicilios: []
            },
            domicilioSeleccionado: null,
            contRenderDomicilios: 0,
            domicilioTmpNotificacionMultiple: null, // para los casoso de notificacion multiple y cambio de persona de catalogo a cualquier otro tipo
            RELACION_MUNICIPIOS_JURISDICCIONES: {
                DIR_NOTIFICADORES_CIVILES: {
                    idRefMunicipio: 1,
                    jurisdiccionCorresponde: 1,
                },
                DIR_JUZGADO_MIXTO_JM: {
                    idRefMunicipio: 3,
                    jurisdiccionCorresponde: 5,
                },
                contRender: 1
            },
        }      
    },
    props: {
        cedulaEditarId: Number
    },
    beforeRouteLeave(to, from, next){
        if(this.dirigir != ''){            
            next();
        }else{                
            //Si la cédula ya fue guardada
            if(this.cedula.CedulaId != undefined && this.cedula.CedulaId > 0){
                //Se verifica que tenga Expeiente y Acuerdo            
                if(this.cedula.Expediente != undefined && this.cedula.Expediente.ExpedienteId > 0 && this.expediente.Acuerdos.length > 0)
                {
                    next();
                }                
                else{                        
                    this.dirigir = to;
                    $('#abandondarPagina_div').modal('show');                  
                }
            }else{
                next();
            }  
        }          
    },
    mounted() {
        
    },
    async created() {
      this.obtenerNumeroDePaginas();
      this.obtenerJurisdicciones();

      if(this.cedulaEditarId != undefined && this.cedulaEditarId > 0){
        this.editar = true;
        this.obtenerCedula({ conActivacionDePestana: true });
      }       
      
      this.datosUsuario();
    },
    computed: {
      mostrarCatalogoTipoDeAudiencias() {
          return (this.TIPOS_CEDULAS.AUDIENCIAS.some(tipoCedula => tipoCedula == this.parametros_TiposCedula.tipoCedulaId));
      },
      mostrarInputsParaSentencias() {
          return (this.TIPOS_CEDULAS.SENTENCIAS.some(tipoCedula => tipoCedula == this.parametros_TiposCedula.tipoCedulaId));
      },
      obtenerPaginacionDePartes() {
        return this.paginacionDePartes(this.partes);
      },
      esJuzgadoMixto() {
          return (this.areaUsuarioJuzgado != undefined && this.areaUsuarioJuzgado != null) 
                    ? (Object.values(enumeraciones.sinoj.juzgadosMixtos).some(jz => jz == this.areaUsuarioJuzgado.AreaId)) ? true : false
                    : false;
      }
    },
    methods: {   
        evtSeguirNotificandoAlMismoExpediente: async function() {
            this.opcionesSeguirNotificando.activado = true;
            manipularVisualizacionModal({ idModal: 'modal-informativo-expediente', mostrar: false });
            await Promise.resolve(this.prepararValoresParaSeguirNotificando());
            $("#datos-generales-cedula-tab").trigger('click');
            console.log('cedulaObj::',this.cedula);
            console.log('personaNotificar::',this.personaANotificar);
        },
        prepararValoresParaSeguirNotificando: async function() {
            const { conDomicilios, conAcuerdos } = this.opcionesSeguirNotificando;

            // limpiar datos de cedula
            this.cedula.CedulaId = -1;
            this.cedula.ArchivoRuta = null;
            this.cedula.AsignacionesDeNotificador = null;
            this.cedula.Expediente.ExpedienteId = -1;
            this.cedula.Estatus = null;
            this.conPersonaMoralYFormulario = false;
            this.cedula.Acuerdos = [];

            //subidor de archivos
            this.contRenderSubidorDocumento ++;
            this.parametros_SubidorDeArchivos.url = null;
            this.archivoCedula = null;
            this.nombreArchivoDeCedula = null;

            // limpiar persona
            this.cedula.PersonasANotificar = null;
            this.personaANotificar = {
                DatosGenerales: null,
                Domicilios: [],
                PersonaId: -1,
                PersonaIdDeReferencia: -1,
                TipoPersona: null,
                TipoPersonalidad: null
            };
            this.tipoDePersona = '3';
            this.personaFisica.nombre = null;
            this.personaFisica.apellidoPaterno = null;
            this.personaFisica.apellidoMaterno = null;
            this.parametros_TipoPersonalidad.tipoPersonalidadId = -1;
            this.parteANotificar = null;
            this.contRenderTPartes ++;

            // persona moral con formulario
            this.conFormulario = false;
            this.auxpersonaANotificar = {};
            /* parametros_TipoPersonalidad.key = ++; */

            if(!conDomicilios) {
                this.domicilioSeleccionado = null;       
                this.conRenderCDomicilios ++;   
                this.domicilioTmpNotificacionMultiple = null;
            }  

            // limpiar acuerdos
            /* const LIMPIAR_ACUERDOS = (conAcuerdos && campoEsValido({ campoAValidar: this.cedula.Acuerdos }));
            this.cedula.Acuerdos = (LIMPIAR_ACUERDOS) ? this.cedula.Acuerdos.map(a => ({ ...a, AcuerdoId: -1 })) : []; */
            this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados = (!conAcuerdos) ? [] : this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados;
            this.FechasDeEmision = (!conAcuerdos) ? [] : this.FechasDeEmision;
        },
        evtNoSeguirNotificando: function() {
            manipularVisualizacionModal({ idModal: 'modal-informativo-expediente', mostrar: false });
            this.opcionesSeguirNotificando.activado = false;
            this.limpiarVista();
        },
        evtDomicilioPrincipalEmpresa: function(domicilio) {
            console.log('objDomicilioEmpresa::',domicilio);
            if(this.parametros_Empresas.objetoBD != null && this.parametros_Empresas.objetoBD != undefined) {
                const DOMICILIO_OBJ = this.parametros_Empresas.objetoBD.Domicilios.find(d => d.DomicilioId == domicilio.Folio);
                this.domicilioSeleccionado = (DOMICILIO_OBJ != null && DOMICILIO_OBJ != undefined) ? DOMICILIO_OBJ : null;
                if(this.domicilioSeleccionado != null && this.domicilioSeleccionado != undefined) {
                    this.domicilioSeleccionado.DomicilioId = -1;
                }
            }
            else {
                this.domicilioSeleccionado = null;
            }
        },
        evtObtenerDomicilioPrincipal: function(domicilio) { debugger
            this.domicilioSeleccionado = { ...domicilio };
            this.domicilioSeleccionado.Domicilio.DomicilioId = -1;
            console.log('this.domicilioSeleccionadoExec::',this.domicilioSeleccionado);
            let domicilioValido = (this.domicilioSeleccionado != null && this.domicilioSeleccionado != undefined);
           
            /*if(domicilioValido) {
                let relacionEncontrada = Object.values(this.RELACION_MUNICIPIOS_JURISDICCIONES)
                                               .find(r => r.idRefMunicipio == this.domicilioSeleccionado.idMunicipioFraccFueraDeCatalogo);
                const JURISDICCION_NOTIFICADORES_CIVILES = 1;
                let datos = {};
                datos.target = {};
                datos.target.value = (relacionEncontrada != null && relacionEncontrada != undefined) ? relacionEncontrada.jurisdiccionCorresponde : JURISDICCION_NOTIFICADORES_CIVILES;
                this.cambioDeJurisdiccion(datos);
                this.parametros_Jurisdicciones.jurisdiccionId = datos.target.value;
                this.RELACION_MUNICIPIOS_JURISDICCIONES.contRender ++;
            }*/
        },
        accionesModal: function({ id, accion }) {
            $('#' + id).modal(accion);
        },
        iniciarProcesoGuardarDomicilioAExpediente: async function() {
            this.accionesModal({ id: 'modal-informativo-dom', accion: 'hide' });
            /** modificacion realizada para guardar domicilio a expediente en edicion */
            let expedienteObj = (this.expedienteBase.objeto != null && this.expedienteBase.objeto != undefined) 
                                    ? this.expedienteBase.objeto
                                    : this.cedula.Expediente;
            const PETICION_API = { Expediente: expedienteObj, Domicilio: this.expedienteBase.domicilios[this.expedienteBase.domicilios.length -1].Domicilio, esPrueba: false };

            /* version estable hasta el dia 09/02/2022
                const PETICION_API = { Expediente: this.expedienteBase.objeto, Domicilio: this.expedienteBase.domicilios[this.expedienteBase.domicilios.length -1].Domicilio, esPrueba: false };*/
            console.log('PETICION_API::',PETICION_API);
            const PROCESO_EJECUTADO_CORRECTAMENTE = await Promise.resolve(this.guardarRelacionDomicilioExpedienteBD({ peticion: PETICION_API }));
        },
        guardarRelacionDomicilioExpedienteBD: async function({ peticion, conMensajeDeRespuesta = true }) { 
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_AGREGAR = api.SINOJ.sistema.cedulas.creacion.GuardarRelacionDomcilioExpediente;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_AGREGAR;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    if(conMensajeDeRespuesta && (Satisfactorio != null && Satisfactorio != undefined))
                        comun.mensajeDeAlerta(Satisfactorio);
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        evtCambioTipoNotificador: function(evento, notificadorObj) {
            this.asignacionManualJuzgadosMixtos.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
            this.asignacionManualJuzgadosMixtos.catalogoNotificadores.seleccionado = notificadorObj;
        },
        obtieneFechaActual: function(){            
            var hoy = new Date();  //"2018-06-12T19:30"
            return moment(hoy).format('YYYY-MM-DD HH:MM:SS').split(' ')[0] + "T" + moment(hoy).format('YYYY-MM-DD HH:MM:SS').split(' ')[1];
        } ,
        datosUsuario: async function(){                                            
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
            comun.SeEstaCargandoInformacion(true);            
            const usuarioDatos = await axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.ObtenerDatosUsuario , { esPrueba: false }, headerPeticion);                                    
            
            if (usuarioDatos.data.SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(false);
                console.log(mensajeError);
                router.push({ name: "SINOJ"});
                comun.mensajeDeAlerta(mensajeError, null, null);
            } 
            else {
                //Cargar los dato del usuario                            
                var area = usuarioDatos.data.Usuario.AreaAsignado;                
                this.areaUsuarioJuzgado = usuarioDatos.data.Usuario.AreaAsignado; 

                this.$refs['filtroBusqueda_creacion'].parametros_Area.esInformativo = true;
                this.$refs['filtroBusqueda_creacion'].parametros_Area.areaId = area.AreaId;
                this.$refs['filtroBusqueda_creacion'].parametros_Area.key = 'areaUsuario' + area.AreaId;
                
                this.$refs['filtroBusqueda_creacion'].cambioDeArea({
                    target: { value: area.AreaId }
                });
                                
                this.$refs['filtroBusqueda_creacion'].parametros_Materia.esInformativo = area.Materias.length > 1 ? false: true;
                this.$refs['filtroBusqueda_creacion'].parametros_Materia.key = 'materiaUsuario' + area.Materias[0].MateriaId;
                
                if(area.Materias.length == 1){
                    this.$refs['filtroBusqueda_creacion'].parametros_Materia.materiaId = area.Materias[0].MateriaId;
                
                    this.$refs['filtroBusqueda_creacion'].parametros_TipoDocumento.parametros.MateriaId = area.Materias[0].MateriaId;
                    this.$refs['filtroBusqueda_creacion'].parametros_TipoDocumento.parametros.AreaId = area.AreaId;
                    this.$refs['filtroBusqueda_creacion'].parametros_TipoDocumento.key = "datosUsuario_" + area.Materias[0].MateriaId;
                }                

                //Actualizamos parámetos del subidor
                this.parametros_SubidorDeArchivos.areaId = area.AreaId;
                this.parametros_SubidorDeArchivos.key = "subidor_AreaUsuario" + this.parametros_SubidorDeArchivos.areaId;
                
                this.parametros_SubidorDeArchivosResultado.areaId = area.AreaId;                
                this.parametros_SubidorDeArchivosResultado.key = "subidor_AreaUsuario" + this.parametros_SubidorDeArchivos.areaId;

                //Cargamos Tipos de cédula
                this.$nextTick(() => {
                this.parametros_TiposCedula.parametros.areaId = area.AreaId;
                this.parametros_TiposCedula.Key = "cedula_Area" + area.AreaId;
                });

                comun.SeEstaCargandoInformacion(false);  
            }
        },
        seNotificaEnJuzgadoEvent: function(){                           
            if(this.seNotificaEnJuzgado == "true"){                
                this.$nextTick(() => {
                    if(this.cedula.CedulaId != undefined && this.cedula.CedulaId > 0)
                    {
                        $("#resultado-cedula-tab").removeClass('disabled');
                    }
                });
                this.cedula.SeNotificaEnJuzgado = true;
                this.parametros_SubidorDeArchivosResultado.tipoResultadoId = enumeraciones.sinoj.tiposResultado.Razonada;
                this.parametros_SubidorDeArchivosResultado.key = "subidor_cedulaEditarResultado_resultado" + enumeraciones.sinoj.tiposResultado.Razonada;
                
                //Se cambia área encargada                
                /*antes 
                        this.jurisdicciones.find(jur => jur.Area.AreaId == parseInt(this.parametros_TiposCedula.parametros.areaId));                            
                */
                var jurisdiccionCorrespondiente = this.jurisdicciones.find(jur => jur.JurisdiccionId == this.parametros_Jurisdicciones.jurisdiccionId);
                //alert("cambio: Area: " + this.parametros_TiposCedula.parametros.areaId + " juris id: " + this.parametros_Jurisdicciones.jurisdiccionId + " jurisNueva: " + jurisdiccionCorrespondiente.JurisdiccionId);                        
                this.parametros_Jurisdicciones.jurisdiccionId = parseInt(jurisdiccionCorrespondiente.JurisdiccionId);
                this.parametros_Jurisdicciones.areasDeJurisdiccion = jurisdiccionCorrespondiente.AreasDeJurisdiccion;
                this.parametros_Jurisdicciones.key = "jurisdiccionJuzgado_" + jurisdiccionCorrespondiente.JurisdiccionId;               

            }else{
                this.$nextTick(() => {                    
                    $("#resultado-cedula-tab").addClass('disabled');                  
                });
                this.cedula.SeNotificaEnJuzgado = false;
                this.cedula.EsDeEstrado = false;
                this.esEstrado = false;
                this.parametros_SubidorDeArchivosResultado.tipoResultadoId = -1;
                this.parametros_SubidorDeArchivosResultado.key = "subidor_cedulaEditarResultado_resultado";                     
            }
        },
        mostrarEstrado: function(){
            var areaId = this.$refs['filtroBusqueda_creacion'].parametros_Area.areaId;            
                if(this.listaDeMixtos.includes(areaId)){
                    return false;
                }
                else {
                    return true;
                }
        },
        esEstradoEvent: function(){              
            this.cedula.EsDeEstrado = this.esEstrado;          
        },
        esOrdenDeProteccionEvent: function(evento){
            console.log('evento::' + evento.target.value);
            this.cedula.EsOrdenDeProteccion = this.esOrdenDeProteccion; 
            this.habilitarOrdenProteccion = (evento.target.value == 'true') ? true : false;    
        },
        cancelarCedula: function(){   
            $('#abandondarPagina_div').modal('hide');              
            if(this.dirigir != ''){
                this.cedula.MotivoDeCancelacion = "Abandono de la páginas sin terminar datos de cédula."
                const parametros = {
                    EsPrueba: this.enumeraciones.EsPrueba,
                    cedula: this.cedula
                }        

                const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

            axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.CancelarCedula, parametros, headerPeticion)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                    comun.mensajeDeAlerta("La cédula ha sido cancelada. Se continuará con la vista solicitada.", null, null);
                    Router.push({ name: this.dirigir.name}); 
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })                                 
            }        
        },
        avanzarDePestana: function(evento) {                          

            const pestañaId = evento.target.getAttribute('id');
            switch(pestañaId) { 
                case 'btn-busqueda-expediente':
                    $("#busqueda-expediente-cedula-tab").removeClass('active');
                    $("#datos-generales-cedula-tab").removeClass('disabled');
                    $("#datos-generales-cedula-tab").trigger('click');
                    this.$nextTick(() => {
                        $('html, body').animate({ scrollTop:0 }, 'slow'); 
                    });   
                    break;
                case 'btn-datos-generales':
                    //Se valida la información
                    this.validaNotificaJuzgado();
                    if(this.validaJurisciccion()){
                        comun.mensajeDeAlerta("La jurisdicción no puede ser igual que el juzgado que notifica.", null, null);
                        return false;
                    }
                    this.GuardarDatosGenerales();                    
                    break;
                case 'btn-datos-plantilla':                    
                    this.subirArchivo();                    
                    break;
                case 'btn-datos-acuerdos':
                    var hayAcuerdoPrincipal = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.find(acuerdo => acuerdo.AcuerdoIdReferencia == this.parametros_listaDeAcuerdos.acuerdoPrincipal);
                    if(hayAcuerdoPrincipal == undefined) 
                    {
                        comun.mensajeDeAlerta("Favor de indicar un acuerdo principal", null, null);
                        return false;
                    } 
                                      
                    if(this.cedula.TipoCedula.TipoCedulaId == 1 || this.cedula.TipoCedula.TipoCedulaId == 10 ||this.cedula.TipoCedula.TipoCedulaId == 18){
                        if(hayAcuerdoPrincipal.FechaDeAudiencia == undefined || hayAcuerdoPrincipal.FechaDeAudiencia == null){
                            comun.mensajeDeAlerta("Favor de indicar una fecha para el acuerdo principal", null, null);
                            return false;
                        }
                        let hoy =  new Date().toISOString().slice(0,10);                      
                        let fechaAcuerdoValida = true;                            
                        this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.forEach(element => {          
                            if(element.FechaDeAudiencia != null){
                            if(element.FechaDeAudiencia.slice(0,10) < hoy)
                                fechaAcuerdoValida = false;
                            }                            
                        })                        
                        if(!fechaAcuerdoValida){
                            comun.mensajeDeAlerta("No se permiten fechas de audiencia anteriores al dia actual.", null, null);
                            return false;
                        }                        
                    }
                    this.guardarAcuerdos();              
                    break;
                case 'btn-guardar-cedula':
                    this.subirArchivo();                       
                    break;
                case 'btn-resultado-cedula':
                    this.GuardarResultado();
                    break;
                default:
                    break;
                
            } 
            /* this.$nextTick(() => {
                $('html, body').animate({ scrollTop:0 }, 'slow'); 
            });    */        
        },
        cargarDomiciliosDeExpedienteBase: function() {
            if(this.expedienteBase.objeto != null && this.expedienteBase.objeto != undefined) {
                const { Domicilios } = this.expedienteBase.objeto;
                this.$nextTick(() => { 
                    if(Domicilios != null && Domicilios.length > 0) {
                        this.$refs['FormEmpresaDomicilio'].domicilios = Domicilios.map(d => {
                            let domicilioObj = {
                                Domicilio: d,
                                idReferencia: null
                            }
                            return domicilioObj;
                        });
                        let domiciliosFormatoTabla = [];
                        let contDomicilios = 1;
                        console.log('domRef::',this.$refs['FormEmpresaDomicilio'].domicilios);
                        this.$refs['FormEmpresaDomicilio'].domicilios.forEach(d => {
                            d.idReferencia = contDomicilios;
                            let fraccionamientoObj = d.Domicilio.Fraccionamiento;
                            if(fraccionamientoObj == null || fraccionamientoObj == undefined) {
                                if(d.Domicilio.FraccionamientoFueraDeCatalogo != null && d.Domicilio.FraccionamientoFueraDeCatalogo != undefined) {
                                    const DATOS_FRACCIONAMIENTO = d.Domicilio.FraccionamientoFueraDeCatalogo.split(',');
                                    if(DATOS_FRACCIONAMIENTO != null && DATOS_FRACCIONAMIENTO != undefined && DATOS_FRACCIONAMIENTO.length > 0) {
                                        fraccionamientoObj = { Nombre: DATOS_FRACCIONAMIENTO[0], Municipio: { Nombre: DATOS_FRACCIONAMIENTO[DATOS_FRACCIONAMIENTO.length -1] }, CodigoPostal: 20000 }
                                    }
                                }
                            }
                            let objDomiciloTabla = {
                                Folio: contDomicilios,
                                domicilio: `${d.Domicilio.Calle} ${d.Domicilio.NumeroExterior} ${ (d.Domicilio.InformacionAdicionalDeNumeroExterior != null && d.Domicilio.InformacionAdicionalDeNumeroExterior != undefined && d.Domicilio.InformacionAdicionalDeNumeroExterior != '') ? (d.Domicilio.InformacionAdicionalDeNumeroExterior + ',') : '' } ${ (d.Domicilio.NumeroInterior != null && d.Domicilio.NumeroInterior != undefined && d.Domicilio.NumeroInterior != '') ? d.Domicilio.NumeroInterior : '' }, ${fraccionamientoObj.Nombre}, ${fraccionamientoObj.Municipio.Nombre}, ${fraccionamientoObj.CodigoPostal}, MEX`
                            }
                            domiciliosFormatoTabla.push(objDomiciloTabla);
                            contDomicilios ++;
                        });
                        this.$refs['FormEmpresaDomicilio'].domiciliosTabla = domiciliosFormatoTabla;
                        this.$refs['FormEmpresaDomicilio'].contadorDomicilios = domiciliosFormatoTabla.length;
                        this.listaDeDomicilios = this.$refs['FormEmpresaDomicilio'].domicilios;
                    }
                });
            }
        },
        validaNotificaJuzgado: function(){
            /*alert("juzgado: " + this.cedula.SeNotificaEnJuzgado + " estrado: " + this.cedula.EsDeEstrado);
            alert(this.SeNotificaEnJuzgado);*/
            
            if(this.cedula.SeNotificaEnJuzgado == undefined || this.cedula.SeNotificaEnJuzgado == false){
                this.cedula.SeNotificaEnJuzgado = false;
                this.cedula.EsDeEstrado = false;
                this.esEstrado = false;
                //alert(this.cedula.EsDeEstrado);
            }
            if(this.cedula.EsDeEstrado == undefined){
                this.cedula.EsDeEstrado = false;
            }
            //alert("juzgado: " + this.cedula.SeNotificaEnJuzgado + " estrado: " + this.cedula.EsDeEstrado);
        },
        validaJurisciccion: function(){

            const areaId = this.$refs['filtroBusqueda_creacion'].parametros_Area.areaId;            
            if(!this.listaDeMixtos.includes(areaId)){	
            var jurisdiccionCorrespondiente = this.jurisdicciones.find(jur => jur.JurisdiccionId == this.parametros_Jurisdicciones.jurisdiccionId);        
            //alert("JUZGADO? " + this.cedula.SeNotificaEnJuzgado + " AreaID: " + areaId + " JurisArea: " + jurisdiccionCorrespondiente.Area.AreaId + " jurisID: " + this.parametros_Jurisdicciones.jurisdiccionId);
            if(this.cedula.SeNotificaEnJuzgado == false && (jurisdiccionCorrespondiente.Area.AreaId == areaId))
                return true;
            else 
                return false;
            }
                return false;
        }, 
        continuarExpediente: function(){ 
            //Para cambio de pestañas
            $("#busqueda-expediente-cedula-tab").removeClass('active');
            $("#datos-generales-cedula-tab").removeClass('disabled');
            $("#datos-generales-cedula-tab").trigger('click');
        },
        cambioTipoDePersona: function(evento) {      
            this.tipoDePersona = evento.target.value;
            if(this.tipoDePersona == '3') {
                this.pagina = 1;
                $("#tablaCedulas input[type='checkbox']").prop('checked', false);
                this.parteANotificar = {};
                this.$nextTick(() => {
                    $("#" + 'paginacion-tabla-partes-creacionCedula ' + "li").removeClass('active');
                    $("#" + 'tabla-partes-creacionCedula'+ 'pagina' + this.pagina).addClass('active');
                });
            }

            /* Version funcional hasta la fecha 04/02/2022
             * Motivo de modificacion: al momento de cambiar la personalidad elimina los domicilios temporales en memoria y la seleccion
                                       de uno de ellos.
            ##########################   CODIGO ###################################################################################
            this.cargarDomiciliosDeExpedienteBase();   

            // modificacion 11/10/2021
            if(this.opcionesSeguirNotificando.activado && !this.opcionesSeguirNotificando.conDomicilios) {
                this.parametros_Empresas.objetoBD = null;
                this.parametros_Empresas.domicilios = [];
                this.domicilioSeleccionado = null;
            }
            else if(!this.opcionesSeguirNotificando.activado){
                this.parametros_Empresas.objetoBD = null;
                this.parametros_Empresas.domicilios = [];
                this.domicilioSeleccionado = null;
            } */

            if(this.opcionesSeguirNotificando.activado && !this.opcionesSeguirNotificando.conDomicilios) {
                this.parametros_Empresas.objetoBD = null;
                this.parametros_Empresas.domicilios = [];
                this.domicilioSeleccionado = null;
            }
            
        },
        cambiarRepresentanteLegal: function(evento){
            if(evento == "true")
                this.representanteLegal = true;
            else
                this.representanteLegal = false;
        },
        cambioTipoDeDocumento: function(evento) {
            const tipoDeDocumento = evento.target.options[evento.target.selectedIndex].text;
            this.tipoDocumentoId = evento.target.options[evento.target.selectedIndex].value;
            if((tipoDeDocumento == 'INCIDENTE' || tipoDeDocumento == 'TERCERIA')) {
                if(this.filtrosDeBusqueda.length < 4) {
                    const filtroDeTerceria =  { catalogoId: enumeraciones.sinoj.catalogos.Terceria, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtro-terceria-creacionDeCedula' };
                    this.filtrosDeBusqueda.push(filtroDeTerceria);
                }
            }
            else if(this.filtrosDeBusqueda.length > 3){
                /* let indexTerceria = this.filtrosDeBusqueda.findIndex(filtro =>  filtro.catalogoId == enumeraciones.sinoj.catalogos.Terceria);
                this.filtrosDeBusqueda.splice(indexTerceria,1); */
                this.filtrosDeBusqueda = this.filtrosDeBusqueda.filter(filtro =>  filtro.catalogoId != enumeraciones.sinoj.catalogos.Terceria);
            }
        },        
        cambioDeJurisdiccion(datos){ 
            this.parametros_Jurisdicciones.jurisdiccionId = parseInt(datos.target.value); 
            console.log('jurisdiccionId::' + this.parametros_Jurisdicciones.jurisdiccionId);        
            var jurisdiccionCorrespondiente = this.jurisdicciones.find(jur => jur.JurisdiccionId == parseInt(datos.target.value));          
            this.parametros_Jurisdicciones.areasDeJurisdiccion = jurisdiccionCorrespondiente.AreasDeJurisdiccion;                        
        },
        cambioDeTipoCedula(datos){ 
            this.parametros_TiposCedula.tipoCedulaId = parseInt(datos.target.value);  

            //Actualizamos parámetros del subidor
            this.parametros_SubidorDeArchivos.tipoCedulaId = parseInt(datos.target.value);  
            this.parametros_SubidorDeArchivos.key = "subidor_tipoCedula" + parseInt(datos.target.value);

            this.parametros_SubidorDeArchivosResultado.tipoCedulaId = parseInt(datos.target.value);  
            this.parametros_SubidorDeArchivosResultado.key = "subidor_tipoCedula" + parseInt(datos.target.value);                    
        }, 
        cambioTipoDeAudiencia(datos) { 
            this.parametros_TipoAudiencia.TipoAudienciaId = parseInt(datos.target.value);
            console.log('this.parametros_TipoAudiencia.TipoAudienciaId::',this.parametros_TipoAudiencia.TipoAudienciaId);
        },                      
        validarDatosBusquedaExpediente: function(datos){
          if (datos.MateriaId == null || datos.MateriaId == -1) {
            comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
            return false;
          }
          if (datos.AreaId == null || datos.AreaId == -1) {
            comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
            return false;
          }
          if (datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1) {
            comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
            return false;
          }
          if (datos.NumeroDocumento == null || datos.NumeroDocumento == undefined || datos.NumeroDocumento == "") {
            comun.mensajeDeAlerta("Favor de indicar el consecutivo.", null, null);
            return false;
          }
          return true;
        },                
        async buscarExpediente(conActivacionDePestana = true) {               
          let peticion = {
            MateriaId: this.$store.state.PJ_Catalogos_002Materias["filtro-materia-creacionCedula"],
            AreaId: this.$store.state.PJ_Catalogos_001Areas["filtro-area-creacionCedula"],
            TipoDeDocumentoId: this.$store.state.PJ_Catalogos_004TiposDocumento["filtro-tipoDocumento-creacionCedula"],
            NumeroDocumento: this.$store.state.Comun_Consecutivo,
            NumeroExtra: this.$store.state.Comun_NumeroExtra,
            EsPrueba: this.enumeraciones.EsPrueba,
          }

          if(peticion.AreaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad){
            peticion.NumeroRomano = this.$refs['filtroBusqueda_creacion'].numeroRomano;
            
            if(this.cedula.Expediente.BaseDeDatosId_025DBPJ != null && this.cedula.Expediente.BaseDeDatosId_025DBPJ > 0)
                peticion.BaseDeDatosId = this.cedula.Expediente.BaseDeDatosId_025DBPJ;
            if(this.cedula.Expediente.DocumentoPadreIdReferencia != null && this.cedula.Expediente.DocumentoPadreIdReferencia > 0)
                peticion.DocumentoPadreReferenciaId = this.cedula.Expediente.DocumentoPadreIdReferencia;
          }

          if(this.validarDatosBusquedaExpediente(peticion)){
            comun.SeEstaCargandoInformacion(true);
            
            let data = await axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.ObtenerDocumento,
              peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if (respuesta.data.SiHayError) {
                this.busquedaExpediente = false;
                this.expedienteEncontrado = false;                
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else { 
                  if(respuesta.data.Expediente != null){ 
                        this.expediente = { ...respuesta.data.Expediente };
                        this.expediente.Domicilios = [];
                        // relacion domicilio expediente
                        if(!this.editar) {
                            this.expedienteBase.objeto = respuesta.data.Expediente;
                            console.log('expedienteBase.objeto::',this.expedienteBase.objeto);
                            this.cargarDomiciliosDeExpedienteBase();
                        }

                        if(this.expediente.Juzgado.JuzgadoId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad){
                            this.filtrosEstablecidos.NumeroRomano = this.expediente.NumeroRomano;
                            this.filtrosKey = "Edicion_" + this.filtrosEstablecidos.MateriaId + this.filtrosEstablecidos.AreaId + this.filtrosEstablecidos.TipoDocumentoId + this.filtrosEstablecidos.Consecutivo + this.filtrosEstablecidos.NumeroRomano;
                        }
                        
                        this.obtenerAcuerdos();
                        this.obtenerAnexos();

                        //Para cambio de pestañas
                        this.busquedaExpediente = false;
                        this.expedienteEncontrado = true;                   
                         
                        /* se pasa directamente a datos generales 
                           modificacion 29/10/2021 */
                        this.$nextTick(() => {
                            if(conActivacionDePestana) {
                                $("#busqueda-expediente-cedula-tab").removeClass('active');
                                $("#datos-generales-cedula-tab").removeClass('disabled');
                                $("#datos-generales-cedula-tab").trigger('click');
                            }
                        });
                    }else{
                        comun.mensajeDeAlerta("No se encontró expediente, favor de verificar los datos.", null, null);
                        
                        //Para no cambiar pestañas
                        this.busquedaExpediente = false;
                        this.expedienteEncontrado = false;  
                        
                        this.regresarPestañas(); 
                        this.limpiarVista(false);                           
                    }
              }
              comun.SeEstaCargandoInformacion(false);            
            })
            .then(response => {
              comun.SeEstaCargandoInformacion(false);
            })
            .catch(e => {
              console.log("No Hay Respuesta del Servidor" + e);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
            return data;
          }
        },
        obtenerAcuerdos: function(){
            this.parametros_listaDeAcuerdos.listaDeAcuerdos = [];
            this.expediente.Acuerdos.forEach(element => {
                this.parametros_listaDeAcuerdos.listaDeAcuerdos.push({
                    Folio: element.AcuerdoIdReferencia,
                    TipoDeDocumento: element.TipoDocumento,
                    Extracto: element.Extracto,
                    FechaDePublicacion: moment(element.FechaDePublicacion).format("DD-MM-YYYY")                    
                });
            })
            
            this.parametros_listaDeAcuerdos.key = "acuerdos_actualizar" + this.expediente.ExpedienteId;
        },
        obtenerAnexos: function(){            
            this.parametros_listaDeAnexos.listaDeAnexos = [];
            this.expediente.Anexos.forEach(element => {
                this.parametros_listaDeAnexos.listaDeAnexos.push({                    
                    Cantidad: element.Cantidad,
                    Nombre: element.Nombre                  
                });
            })
            
            this.parametros_listaDeAnexos.key = "anexos_actualizar" + this.expediente.ExpedienteId;
        },
        eventoCambioArea: function(){
            this.busquedaExpediente = true;
            this.expedienteEncontrado = false;
            //Actualizamos jurisdicción            
            const areaId = this.$refs['filtroBusqueda_creacion'].parametros_Area.areaId;
            var jurisdiccionCorrespondiente = this.jurisdicciones.find(function(item) {
                if(item.AreasDeJurisdiccion.some(area => area.AreaId == areaId))
                    return item;
                else
                    return null;
            })      

            //Actualizamos parámetos del subidor
            this.parametros_SubidorDeArchivos.areaId = this.$store.state.PJ_Catalogos_001Areas["filtro-area-creacionCedula"];
            this.parametros_SubidorDeArchivos.key = "subidor_" + this.parametros_SubidorDeArchivos.areaId;

            this.parametros_SubidorDeArchivosResultado.areaId = this.$store.state.PJ_Catalogos_001Areas["filtro-area-creacionCedula"];
            this.parametros_SubidorDeArchivosResultado.key = "subidor_" + this.parametros_SubidorDeArchivos.areaId;

            if(jurisdiccionCorrespondiente != undefined){
                this.parametros_Jurisdicciones.jurisdiccionId = jurisdiccionCorrespondiente.JurisdiccionId;
                this.parametros_Jurisdicciones.areasDeJurisdiccion = jurisdiccionCorrespondiente.AreasDeJurisdiccion;
                this.parametros_Jurisdicciones.key = "jurisdiccion_creacionCedula_" + jurisdiccionCorrespondiente.JurisdiccionId;                

                //Se actualiza Tipos de cédula según área
                this.parametros_TiposCedula.parametros.areaId =  this.$store.state.PJ_Catalogos_001Areas["filtro-area-creacionCedula"];
                if (this.parametros_TiposCedula.tipoCedulaId <= 0)
                    this.parametros_TiposCedula.key = "TipoCedula_" + jurisdiccionCorrespondiente.JurisdiccionId;
            }
        },
        eventoCambioMateria: function(evento) {
            this.busquedaExpediente = true;
            this.expedienteEncontrado = false;
        },  
        eventoCambioDeEmpresa: function(evento, objeto){ 
            console.log('objEmpresa::',objeto)
            this.parametros_Empresas.objetoBD = objeto;
            this.parametros_Empresas.empresaId = Number(objeto.EmpresaId);
            this.parametros_Empresas.notificador = objeto.Notificador;
            this.parametros_RepresentantesLegales.parametros.EmpresaId = objeto.EmpresaId;
            this.parametros_RepresentantesLegales.key = "representanteslegales_" + objeto.EmpresaId;
            this.parametros_RepresentantesLegales.textoSelect = 'representante legal';   
            this.parametros_RepresentantesLegales.listadoRepresentantesLegales = objeto.RepresentantesLegales;
            this.parametros_Empresas.parametros.Nombre = objeto.Nombre;
            
            this.obtenerDomciciliosDeEmpresa(objeto);

            this.parametros_Empresas.representantesLegales = [];
            objeto.RepresentantesLegales.forEach(element => {
                this.parametros_Empresas.representantesLegales.push({ 
                    llave: element.PersonaId, 
                    valor: element.DatosGenerales.Fisica.Nombre + " " + element.DatosGenerales.Fisica.ApellidoPaterno + " " + element.DatosGenerales.Fisica.ApellidoPaterno 
                });    
            })       

            // modificacion realizada 10/02/0
            /* if(this.opcionesSeguirNotificando.activado && this.opcionesSeguirNotificando.conDomicilios) {
                this.domicilioTmpNotificacionMultiple = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null && this.domicilioSeleccionado.Domicilio != undefined)
                    ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;
            } */

            this.domicilioTmpNotificacionMultiple = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null && this.domicilioSeleccionado.Domicilio != undefined)
                    ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;

            this.domicilioSeleccionado = null;               
        },     
        eventoCambioDeRepresentante:function(evento){
            this.parametros_RepresentantesLegales.representantesLegales = [];
            const representante = this.parametros_RepresentantesLegales.listadoRepresentantesLegales.find(element => element.PersonaId == evento.target.value);
            
            //Para hacer un registro nuevo de persona
            representante.PersonaIdDeReferencia = representante.PersonaId;
            representante.PersonaId = -1;
            representante.DatosGenerales.Fisica.FisicaId = -1;
            this.parametros_RepresentantesLegales.representantesLegales.push(representante)
        },
        cambioDeTipoDePersonalidad: function(evento){
            this.parametros_TipoPersonalidad.tipoPersonalidadId = Number(evento.target.value);
        },     
        obtenerDomciciliosDeEmpresa: function(objeto){
            this.parametros_Empresas.domicilios = [];
            // modificacion 11/10/2021
            this.personaANotificar.Domicilios = [];

            // objeto.Domicilios.forEach(element => {                
            //     this.parametros_Empresas.domicilios.push({
            //         Folio: element.DomicilioId,
            //         Calle: element.Calle,
            //         Numero: element.NumeroExterior + (element.NumeroInterior != null ? " " + element.NumeroInterior : ""),
            //         Fraccionamiento: element.Fraccionamiento.Nombre,
            //         CodigoPostal: element.Fraccionamiento.CodigoPostal,
            //         Municipio: element.Fraccionamiento.Municipio.Nombre,
            //         Referencias: element.Referencias
            //     });

            //     //Para hacer un nuevo registro de domicilio y sus coordenadas
            //     let objNuevoDomicilio = { ...element };
            //     objNuevoDomicilio.DomicilioId = -1;                
            //     objNuevoDomicilio.Coordenadas.forEach(element => {
            //         element.CoordenadaId = -1
            //     })
                
            //     this.personaANotificar.Domicilios.push(objNuevoDomicilio);
            // });
            objeto.Domicilios.forEach(element => {             
                console.log(element);
                if(element.Fraccionamiento != null){                   
                    this.parametros_Empresas.domicilios.push({
                        Folio: element.DomicilioId,
                        Calle: element.Calle,
                        Numero: element.NumeroExterior + (element.NumeroInterior != null ? " " + element.NumeroInterior : ""),
                        Fraccionamiento: element.Fraccionamiento.Nombre,
                        CodigoPostal: element.Fraccionamiento.CodigoPostal,
                        Municipio: element.Fraccionamiento.Municipio.Nombre,
                        Referencias: element.Referencias
                    });
                }
                else{          
                    this.parametros_Empresas.domicilios.push({
                        Folio: element.DomicilioId,
                        Calle: element.Calle,
                        Numero: element.NumeroExterior + (element.NumeroInterior != null ? " " + element.NumeroInterior : ""),
                        Fraccionamiento: element.FraccionamientoFueraDeCatalogo.substring(0, element.FraccionamientoFueraDeCatalogo.length - element.FraccionamientoFueraDeCatalogo.split(",")[element.FraccionamientoFueraDeCatalogo.split(",").length - 1].length - 1),
                        CodigoPostal: 20000,
                        Municipio: element.FraccionamientoFueraDeCatalogo.split(",")[element.FraccionamientoFueraDeCatalogo.split(",").length - 1] ,
                        Referencias: element.Referencias
                    });
                }

                //Para hacer un nuevo registro de domicilio y sus coordenadas
                let objNuevoDomicilio = { ...element };
                objNuevoDomicilio.DomicilioId = -1;                
                objNuevoDomicilio.Coordenadas.forEach(element => {
                    element.CoordenadaId = -1
                })
                
                this.personaANotificar.Domicilios.push(objNuevoDomicilio);
            });
        },
        obtenerListadoDeDomicilios: function(evento, accion){                  debugger    
            this.listaDeDomicilios = evento;  
            this.expedienteBase.domicilios = evento;
            if(accion.accion != 'remover' && !accion.enEdicion)
                $('#modal-informativo-dom').modal('show');
        },
        obtenerJurisdicciones: function(){
            const parametros = {
                EsPrueba: this.enumeraciones.EsPrueba,
                conAreasDeJurisdiccion: true
            }        

            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

            axios.post(api.conexion + api.SINOJ.catalogos.C003Jurisdicciones, parametros, headerPeticion)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                    this.jurisdicciones = respuesta.data.Jurisdicciones;
                    
                    this.eventoCambioArea();
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
        },        
        obtenerPersonaMoral: function(evento){        
            this.auxpersonaANotificar = evento;       
            this.conFormulario = true;     
            //this.$refs['registroAltaEmpresaForm'].evtGuardarEmpresa(this.personaANotificar);            
        },
        ValidarPersonaANotificar: function(){ 
            switch(this.tipoDePersona)
            {
                case "1":
                    if(this.personaFisica.nombre == "" || (this.personaFisica.apellidoPaterno == "" && this.personaFisica.apellidoMaterno == ""))
                        return false
                    break;
                case "2":
                    if(this.conCatalogo){
                        /* antes de la modificacion 11/10/2021
                         if(this.parametros_Empresas.empresaId == undefined || this.parametros_Empresas.empresaId <= 0)                        
                        { 
                            return false; 
                        } */
                        if((this.parametros_Empresas.empresaId == undefined || this.parametros_Empresas.empresaId <= 0) || (this.domicilioSeleccionado == null || this.domicilioSeleccionado == undefined))                        
                        { 
                            return false; 
                        }
                        // if(this.parametros_RepresentantesLegales.representantesLegales == undefined && this.parametros_RepresentantesLegales.representantesLegales.length <= 0)                        
                        //     return false;                                                
                        // if(this.parametros_TipoPersonalidad.tipoPersonalidadId == "-1" && this.parametros_TipoPersonalidad.tipoPersonalidadId == null)                        
                        //     return false;                    
                    }
                    break;
                case "3": 
                    if(this.seNotificaEnJuzgado == 'true' && this.esEstrado == 'true'){
                        if(this.personasANotificar.length <= 0)
                            return false;      
                    }else{
                        if ((this.personaANotificar.PersonaId == undefined || this.personaANotificar.PersonaId <= 0) && 
                            (this.personaANotificar.PersonaIdDeReferencia == undefined || this.personaANotificar.PersonaIdDeReferencia <= 0))
                        return false;  
                    }               
                    break;
            }
            return true;
        },
        ValidarDatosGenerales: function(){ 
            if(this.ValidarPersonaANotificar()){
                if (this.parametros_Jurisdicciones == null || this.parametros_Jurisdicciones.jurisdiccionId == -1) {                    
                    return false;
                }
                if (this.parametros_TiposCedula == null || this.parametros_TiposCedula.tipoCedulaId == -1) {            
                    return false;
                }  
                /* Antes de la seleccion de domicilio 07/10/2021
                if(this.tipoDePersona == "2" && this.conFormulario && this.listaDeDomicilios.length <= 0){                    
                    return false;
                }             
                if(this.tipoDePersona != "2" && this.seNotificaEnJuzgado == "false" && this.listaDeDomicilios.length <= 0){                    
                    return false;
                } */
                if(this.tipoDePersona == "2" && this.conFormulario && (this.domicilioSeleccionado == null || this.domicilioSeleccionado == undefined)){                    
                    return false;
                }
                if(this.tipoDePersona != "2" && this.seNotificaEnJuzgado == "false" && (this.domicilioSeleccionado == null || this.domicilioSeleccionado == undefined)){                    
                    return false;
                }
                return true;
            }else{
                return false;
            }            
        },     
        crearPersonaANotificar: function(){ debugger
            switch(this.tipoDePersona){
                case "1": //Persona física                
                    this.personaANotificar.Domicilios = [];
                    /*  Antes de modificacion multiple de domicilios
                        this.listaDeDomicilios.forEach(element => {
                        this.personaANotificar.Domicilios.push(element.Domicilio);    
                    });  */    
                    /*  version estable hasta el 10/02/20222 
                    if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false')               
                        this.personaANotificar.Domicilios.push(this.domicilioSeleccionado.Domicilio);   */ 

                    /* if(this.opcionesSeguirNotificando.activado && this.opcionesSeguirNotificando.conDomicilios) {
                        if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false') {
                            let domicilioObjTmp = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null)
                                ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;
                            this.personaANotificar.Domicilios.push(domicilioObjTmp.Domicilio);
                            this.domicilioTmpNotificacionMultiple = null;
                        }  
                    }
                    else {
                        if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false')               
                            this.personaANotificar.Domicilios.push(this.domicilioSeleccionado.Domicilio);
                    } */

                    if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false') {
                        let domicilioObjTmp = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null)
                            ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;
                        this.personaANotificar.Domicilios.push(domicilioObjTmp.Domicilio);
                    }

                    // limpiar variable 
                    let personaFisicaANotificar = {
                        DatosGenerales: { 
                            Fisica : { 
                                Nombre: this.personaFisica.nombre,
                                ApellidoPaterno: this.personaFisica.apellidoPaterno,
                                ApellidoMaterno: this.personaFisica.apellidoMaterno
                            } 
                        },
                        TipoPersonalidad: this.parametros_TipoPersonalidad,
                        TipoPersona: {
                            TipoPersonaId: enumeraciones.pj.tiposPersonas.Fisica
                        },
                        Domicilios: this.personaANotificar.Domicilios
                    }
                    
                    if(this.personaANotificar.PersonaId > 0)
                    {
                        /*personaFisicaANotificar.PersonaId = this.personaANotificar.PersonaId;
                        personaFisicaANotificar.DatosGenerales.Fisica.FisicaId = this.personaANotificar.PersonaId; */
                        personaFisicaANotificar.PersonaId = -1;
                        personaFisicaANotificar.DatosGenerales.Fisica.FisicaId = -1;
                    }

                    this.personaANotificar = personaFisicaANotificar;
                    break;
                case "2": //Persona Moral
                    if(!this.conCatalogo){
                        this.personaANotificar.Domicilios = [];
                        /* Antes de modificacion multiple de domicilios
                        this.listaDeDomicilios.forEach(element => {
                            this.personaANotificar.Domicilios.push(element.Domicilio);    
                        });  */                             
                        
                        // version estable hasta 10/02/2022 => this.personaANotificar.Domicilios.push(this.domicilioSeleccionado.Domicilio); 
                        let domicilioObjTmp = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null)
                                ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;
                            this.personaANotificar.Domicilios.push(domicilioObjTmp.Domicilio);     
                    }else{                           
                        var representantes = [];

                        if(this.representanteLegal){
                            representantes = this.parametros_RepresentantesLegales.representantesLegales;
                        }else{
                            var personaUniversal = {
                                DatosGenerales: {
                                    Fisica: {
                                        Nombre: this.representanteUniversal
                                    }
                                },
                                TipoPersona: {
                                    TipoPersonaId: 2
                                },                                
                            }
                            representantes.push(personaUniversal);
                        }

                        // modificacion 11/10/2021
                        this.personaANotificar.Domicilios = [];     
                        // Nota: para el caso de personas morales el domicilio no viene con la estructura { idReferencia, Domicilio } que se manejaba en la tabla de personas fisicas y morales por medio de formulario
                        // aqui se puede omitir ese paso y enviar el objeto completo this.domicilioSeleccionado         
                        this.personaANotificar.Domicilios.push(this.domicilioSeleccionado);   

                        let personaMoral = {
                            DatosGenerales: { 
                                Moral : { 
                                    Nombre: this.parametros_Empresas.parametros.Nombre,
                                    RepresentantesLegales: representantes
                                } 
                            },
                            TipoPersonalidad: this.parametros_TipoPersonalidad,
                            TipoPersona: {
                                TipoPersonaId: enumeraciones.pj.tiposPersonas.Moral
                            },
                            Domicilios: this.personaANotificar.Domicilios
                        }
                        
                        if(this.personaANotificar.PersonaId > 0)
                        {
                            personaMoral.PersonaId = this.personaANotificar.PersonaId;
                            personaMoral.DatosGenerales.Moral.MoralId = this.personaANotificar.PersonaId;
                        }

                        this.personaANotificar = personaMoral;
                    } 
                    break;
                case "3": //Parte
                    this.personaANotificar.Domicilios = [];
                    /* Antes de modificacion multiple de domicilios
                    this.listaDeDomicilios.forEach(element => { 
                        this.personaANotificar.Domicilios.push(element.Domicilio);    
                    });   */   

                    /* version estable hasta 10/02/2022  
                    if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false')            
                        this.personaANotificar.Domicilios.push(this.domicilioSeleccionado.Domicilio);  */ 
                        
                    if((this.esEstrado == 'false' && this.seNotificaEnJuzgado == 'false') ||  this.seNotificaEnJuzgado == 'false') {
                        let domicilioObjTmp = (this.domicilioSeleccionado != null && this.domicilioSeleccionado.Domicilio != null)
                            ? this.domicilioSeleccionado : this.domicilioTmpNotificacionMultiple;
                        this.personaANotificar.Domicilios.push(domicilioObjTmp.Domicilio);
                    }  
                    break;
            }          
        },   
        crearDatosGeneralesCedula: function(){ debugger
            this.crearPersonaANotificar();                      
            
            let cedulaId = 0;
            //Si la cédula ya existe
            if(this.cedula.CedulaId != undefined && this.cedula.CedulaId > 0)
                cedulaId = this.cedula.CedulaId;
            
            let jurisdiccion = this.cedula.Jurisdiccion;
            jurisdiccion.JurisdiccionId = this.parametros_Jurisdicciones.jurisdiccionId;
            jurisdiccion.areasDeJurisdiccion = this.parametros_Jurisdicciones.areasDeJurisdiccion;

            var tipoEstatusId = 0;
            if(this.editar){                
                tipoEstatusId =  enumeraciones.sinoj.tiposEstatus.creada;
            }else{               
                tipoEstatusId = enumeraciones.sinoj.tiposEstatus.incompleta;
            }

            let personasQueSeNotifican = [];
            //Se valida si es de estrados puede tener más de una persona a notificar
            if(this.seNotificaEnJuzgado == 'true' && this.esEstrado == 'true')
            {
                personasQueSeNotifican.push(this.personaANotificar);
            }else{
                if(this.conFormulario && this.tipoDePersona == '2'){  
                    var conPersonaMoralYFormulario = true;                                   
                    this.auxpersonaANotificar.persona.Domicilios = this.personaANotificar.Domicilios;
                    console.log('this.personaANotificar.Domicilios::',this.personaANotificar.Domicilios);
                    //console.log(this.auxpersonaANotificar);
                    for (var i = 0; i < this.auxpersonaANotificar.persona.DatosGenerales.Moral.RepresentantesLegales.length; i++){                        
                        this.auxpersonaANotificar.persona.DatosGenerales.Moral.RepresentantesLegales[i].TipoPersonalidad = this.auxpersonaANotificar.persona.TipoPersonalidad;
                    }
                    personasQueSeNotifican.push(this.auxpersonaANotificar.persona);                   
                }
                else
                personasQueSeNotifican.push(this.personaANotificar);
            }

            if(!this.editar) {
                let cedulaDatosGenerales = {
                    CedulaId: cedulaId,
                    Estatus: { TipoEstatusId: tipoEstatusId },
                    TipoCedula: { TipoCedulaId: this.parametros_TiposCedula.tipoCedulaId },
                    Jurisdiccion: jurisdiccion,
                    PersonasANotificar: personasQueSeNotifican,
                    SeNotificaEnJuzgado: this.seNotificaEnJuzgado,
                    EsDeEstrado: this.esEstrado,
                    EsOrdenDeProteccion: this.esOrdenDeProteccion,
                    Urgente: this.esUrgente,   
                    TipoAudiencia: this.parametros_TipoAudiencia.TipoAudienciaId > 0 ? { TipoAudienciaId : this.parametros_TipoAudiencia.TipoAudienciaId }: null,    
                    NumeroDeFojas: this.cedula.NumeroDeFojas,
                    DiasDeTermino: this.cedula.DiasDeTermino,
                    FechaDeDictadoDeSentencia: this.cedula.FechaDeDictadoDeSentencia,
                    Expediente: this.cedula.Expediente,
                    Notificador: this.parametros_Empresas.notificador != undefined ? this.parametros_Empresas.notificador : null,
                    conPersonaMoralYFormulario: conPersonaMoralYFormulario
                }
                
                //Si ya existe archivo
                if(this.cedula.ArchivoRuta != null && this.cedula.ArchivoRuta != undefined)
                    cedulaDatosGenerales.ArchivoRuta = this.cedula.ArchivoRuta;
                
                this.cedula = cedulaDatosGenerales;
            }
            else {
                this.cedula.CedulaId = cedulaId;
                this.cedula.Estatus.TipoEstatusId = tipoEstatusId;
                this.cedula.TipoCedula.TipoCedulaId = this.parametros_TiposCedula.tipoCedulaId;
                this.cedula.Jurisdiccion = jurisdiccion;
                this.cedula.PersonasANotificar = personasQueSeNotifican;
                this.cedula.SeNotificaEnJuzgado = this.seNotificaEnJuzgado;
                this.cedula.EsDeEstrado = this.esEstrado;
                this.cedula.EsOrdenDeProteccion = this.esOrdenDeProteccion;
                this.cedula.Urgente = this.esUrgente;   
                this.cedula.TipoAudiencia = null;
                this.parametros_TipoAudiencia = (this.parametros_TipoAudiencia != null && this.parametros_TipoAudiencia != undefined)
                    ? this.parametros_TipoAudiencia : { TipoAudienciaId: -1, parametros: { soloEquitas: true }, key: '' };
                if(this.parametros_TipoAudiencia.TipoAudienciaId > 0) {
                    if(this.cedula.TipoAudiencia == null || this.cedula.TipoAudiencia == undefined) {
                        this.cedula.TipoAudiencia = { TipoAudienciaId: -1 };
                    }
                    this.cedula.TipoAudiencia.TipoAudienciaId = this.parametros_TipoAudiencia.TipoAudienciaId; 
                }   
                this.cedula.NumeroDeFojas = this.cedula.NumeroDeFojas;
                this.cedula.DiasDeTermino = this.cedula.DiasDeTermino;
                this.cedula.FechaDeDictadoDeSentencia = this.cedula.FechaDeDictadoDeSentencia;
                this.cedula.Expediente = this.cedula.Expediente;
                this.cedula.Notificador = this.parametros_Empresas.notificador != undefined ? this.parametros_Empresas.notificador : null;
                this.cedula.conPersonaMoralYFormulario = conPersonaMoralYFormulario;
            }
        },
        establecerUrgencia: function(value){
            this.esUrgente = value;
        },
        GuardarDatosGenerales: function(){ debugger
            if(this.ValidarDatosGenerales()){
                comun.SeEstaCargandoInformacion(true);
                this.crearDatosGeneralesCedula();                                

                const peticion = { 
                    Cedula : this.cedula
                }                                
                //console.log("cedula");
                //console.log(peticion);

                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.GuardarDatosGeneralesCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {  
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                        comun.SeEstaCargandoInformacion(false);
                    } else { 
                        this.cedula.CedulaId = respuesta.data.Cedula.CedulaId;
                        
                        if((this.seNotificaEnJuzgado == 'false' && this.esEstrado == 'false') || (this.seNotificaEnJuzgado == 'false' && this.esEstrado == false)){
                            this.personaANotificar = respuesta.data.Cedula.PersonasANotificar[0];
                            /* Antes de la seleccion unica de domicilios
                            this.listaDeDomicilios = [];
                            this.personaANotificar.Domicilios.forEach(element => {                                                
                                let agregar = {
                                    Domicilio: element
                                }
                                this.listaDeDomicilios.push(agregar);
                            });                        
                                                
                            if(this.$refs['FormEmpresaDomicilio'] != undefined){ 
                                this.$refs['FormEmpresaDomicilio'].limpiarDomiciliosTablas();
                                this.$refs['FormEmpresaDomicilio'].cargarDomiciliosGuardados(this.personaANotificar.Domicilios);
                            } */  
                        }else{
                            this.personasANotificar = respuesta.data.Cedula.PersonasANotificar;
                            this.cedula.PersonasANotificar = respuesta.data.Cedula.PersonasANotificar;
                        }                                                

                        //Para cambio de pestañas
                        $("#datos-generales-cedula-tab").removeClass('active');                        
                        $("#asignar-acuerdos-tab").removeClass('disabled');
                        /* $("#asignar-acuerdos-tab").trigger('click') */

                        if(!this.opcionesSeguirNotificando.activado) {
                            $("#asignar-acuerdos-tab").trigger('click')
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else if(this.opcionesSeguirNotificando.activado){
                            if(this.opcionesSeguirNotificando.conAcuerdos) {
                                this.guardarAcuerdos();
                            }
                            else {
                                $("#asignar-acuerdos-tab").trigger('click')
                                comun.SeEstaCargandoInformacion(false);
                            }
                        }         
                    }
                    this.$nextTick(() => {
                        $('html, body').animate({ scrollTop:0 }, 'slow'); 
                    });   
                })
                .then(response => {
                    
                })
                .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                });
            }else{
                this.mostrarErroresEnDatosGenerales = true;
                comun.mensajeDeAlerta('Se detectaron campos incorrectos. Favor de verificarlos.', null, null);
            }         
        },
        obtenerCedula: function({ conActivacionDePestana = true })
        {            
            if(this.cedulaEditarId != undefined && this.cedulaEditarId > 0)
                    this.cedula.CedulaId = this.cedulaEditarId;

            if(this.cedula.CedulaId != undefined && this.cedula.CedulaId > 0){                                      
                const peticion = { 
                    EsPrueba: this.enumeraciones.EsPrueba,
                    CedulaId : this.cedula.CedulaId
                }
                                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.ObtenerCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                    } else { 
                        if(respuesta.data.Cedula != null){                            
                            this.cedula = respuesta.data.Cedula;                                                        

                            if(this.cedulaEditarId != undefined && this.cedulaEditarId > 0){                                                                                                                                
                                this.cargarDatosDeCedulaAEditar({ conActivacionDePestana:  conActivacionDePestana }).then((result) => {    
                                    
                                });                                
                                
                            }
                        }else
                            comun.mensajeDeAlerta("No se pudo obtener la cédula.", null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .then(response => {
                    
                })
                .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }else{
                this.mostrarErroresEnDatosGenerales = true;
                comun.mensajeDeAlerta('Se detectaron campos incorrectos. Favor de verificarlos.', null, null);
            }
        },    
        obtenerArchivo: function(evento){
            this.archivoCedula = evento;
            this.obtenerNombreArchivoDeCedula(evento.name);
        },    
        subirArchivo: function() { 
            if(this.archivoCedula != null){
            comun.SeEstaCargandoInformacion(true);            
            let datosDelFormulario = new FormData();
                        
            datosDelFormulario.append('Archivo', this.archivoCedula);
            datosDelFormulario.append('CedulaId', this.cedula.CedulaId);                

            datosDelFormulario.append('EsPrueba', this.enumeraciones.EsPrueba);

            axios.post(
                api.conexion + api.SINOJ.sistema.cedulas.creacion.GuardarDocumento,                
                datosDelFormulario,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
            ).then(respuesta => { 
                if(respuesta.data.SiHayError){
                console.log(respuesta);
                  //comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                } else { 
                    //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);    
                    
                    this.cedula.ArchivoRuta = respuesta.data.Ruta;
                    //Para cambio de pestañas                    
                    if(this.seNotificaEnJuzgado == "true")
                    {
                        $("#llenar-plantilla-tab").removeClass('active');                    
                        $("#resultado-cedula-tab").removeClass('disabled');
                        $("#resultado-cedula-tab").trigger('click')                                     
                    }else{
                        $("#llenar-plantilla-tab").removeClass('active');                    
                        $("#crear-cedula-tab").removeClass('disabled');
                        $("#crear-cedula-tab").trigger('click')  
                        this.GuardarCedula();           
                    }
                    
                }                
                comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);                
            }); 
            }else{//Si no hay cambio de archivo
                //Para cambio de pestañas
                    if(this.seNotificaEnJuzgado == "true")
                    {
                        $("#llenar-plantilla-tab").removeClass('active');                    
                        $("#resultado-cedula-tab").removeClass('disabled');
                        $("#resultado-cedula-tab").trigger('click')         
                    }else{
                        $("#llenar-plantilla-tab").removeClass('active');                    
                        $("#crear-cedula-tab").removeClass('disabled');
                        $("#crear-cedula-tab").trigger('click')   
                        this.GuardarCedula();          
                    }  
                    
            }        
        },
        verAcuerdo: function(evento){
            const acuerdo = this.obtenerAcuerdoSeleccionado(evento);
            this.parametros_acuerdoSeleccionado.acuerdo = acuerdo;
            this.parametros_acuerdoSeleccionado.key = "VerAcuerdo_" + acuerdo.AcuerdoIdReferencia
            $('#visor-documento').modal('show');
        },
        obtenerAcuerdoSeleccionado: function(evento) {
            let acuerdo = null;
            const acuerdoSeleccionado = evento.target.getAttribute('id');
            const acuerdoId = parseInt(acuerdoSeleccionado.split('-')[acuerdoSeleccionado.split('-').length - 1]);
            acuerdo = this.expediente.Acuerdos.filter(element => element.AcuerdoIdReferencia == acuerdoId);
            return acuerdo[0];
        },
        acuerdosSeleccionado: function(evento){  
            /* Version anterior - 18/08/2021
                parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados 
                this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados= [];                       
                evento.filter(c => c.enviar).forEach((element) => {                               
                    const acuerdo = this.expediente.Acuerdos.find(acuerdo => acuerdo.AcuerdoIdReferencia == element.folio);
                    this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.push(acuerdo);                    
                });     
            */   

            // Si el acuerdo esta seleccionado lo agrega si no lo remueve de la lista
            if(evento.enviar) {
                if(!this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.some(aSel => aSel.AcuerdoIdReferencia == evento.folio)) {
                    const ACUERDO_OBJ = this.expediente.Acuerdos.find(acuerdo => acuerdo.AcuerdoIdReferencia == evento.folio);
                    this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.push(ACUERDO_OBJ);
                }
            }
            else {
                this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.filter(aSel => aSel.AcuerdoIdReferencia != evento.folio);
            }
            

            if(this.parametros_listaDeAcuerdos.acuerdoPrincipal == undefined){
                this.parametros_listaDeAcuerdos.acuerdoPrincipal = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados[0].AcuerdoIdReferencia;                
            }                
                
            this.parametros_listaDeAcuerdos.numeroDeAcuerdosSeleccionados = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.length;
        },
        obtenFechaConFormato: function(fecha) {   
                            
            if(fecha != null){
                if(fecha.length > 10){
                    fecha = moment(fecha).format("DD-MM-YYYY");
                }
                else{
                    fecha = moment(fecha,"DD/MM/YYYY").format("DD-MM-YYYY");
                }

                return fecha;
            }
            else 
                return ''
        },        
        cambioAcuerdoPrincipal: function(acuerdo){ 
            this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.forEach(element =>{
                element.EsPrincipal = false;
                if(element.AcuerdoIdReferencia == acuerdo.AcuerdoIdReferencia)
                    element.EsPrincipal = true;
            });
            this.parametros_listaDeAcuerdos.acuerdoPrincipal = acuerdo.AcuerdoIdReferencia;
        },
        agregarFechaDeEmision: function(acuerdoAux){
            if(acuerdoAux.FechaDeEmision != null){
                let fecha = acuerdoAux.FechaDeEmision;
                this.FechaDeEmision = null;                
                let acuerdo_seleccionado = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.find(acuerdo => acuerdo.AcuerdoIdReferencia == acuerdoAux.AcuerdoIdReferencia);
                this.contadorFechasEmision ++;

                this.FechasDeEmision.push({
                    ReferenciaId: this.contadorFechasEmision,
                    Fecha: fecha,
                    Acuerdo: acuerdo_seleccionado
                });                
            }
        },
        eliminarFechaEmision: function(fechaEmision){
            let indexFecha = this.FechasDeEmision.findIndex(fecha => fecha.ReferenciaId == fechaEmision.ReferenciaId);
            this.FechasDeEmision.splice(indexFecha,1);
        },
        validarAcuerdos:function(){            
            if(this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.length <= 0){
                comun.mensajeDeAlerta("Favor de indicar al menos un acuerdo.", null, null);
                return false;
            }
            
            //Si es tipo cédula de audiencia o audiencia confesional es obligatoria la fecha.
            if(this.cedula.TipoCedula.TipoCedulaId == 1 || this.cedula.TipoCedula.TipoCedulaId == 10 || this.cedula.TipoCedula.TipoCedulaId == 18){
                var hayfecha = this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.some(acuerdo => acuerdo.FechaDeAudiencia != null);
                if(!hayfecha){
                    comun.mensajeDeAlerta("La cédula es de tipo audiencia, favor de indicar la fecha en el acuerdo correspondiente.", null, null);
                    return false;
                }
            }

            return true;
        },
        guardarAcuerdos: function(){ 
            if(this.validarAcuerdos()){
                comun.SeEstaCargandoInformacion(true);                
                
                const acuerdo = this.expediente.Acuerdos.find(acuerdo => acuerdo.AcuerdoIdReferencia == this.parametros_listaDeAcuerdos.acuerdoPrincipal);
                this.cambioAcuerdoPrincipal(acuerdo);
                
                this.cedula.Acuerdos = [];
                this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.forEach(element => {                    
                    let acuerdo = this.expediente.Acuerdos.find(acuerdo => acuerdo.AcuerdoIdReferencia == element.AcuerdoIdReferencia); 
                    /*Antes  //1                 
                    element.FechaDePublicacion = acuerdo.FechaDePublicacion; 
                    */
                    
                    if(acuerdo.FechaDePublicacion != null && acuerdo.FechaDePublicacion != undefined) {
                        if(acuerdo.FechaDePublicacion.length > 10){
                            element.FechaDePublicacion = moment(acuerdo.FechaDePublicacion).format("MM-DD-YYYY");
                        }
                        else{
                            element.FechaDePublicacion = moment(acuerdo.FechaDePublicacion,"DD/MM/YYYY").format("MM-DD-YYYY");
                        }
                    }

                    element.FechasDeEmision = []
                    if(acuerdo != undefined){
                        let fechasList =this.FechasDeEmision.filter(fecha => fecha.Acuerdo.AcuerdoIdReferencia == element.AcuerdoIdReferencia);
                        if(fechasList.length > 0){                            
                            fechasList.forEach(_fecha => {
                                element.FechasDeEmision.push(
                                    {
                                        Fecha: _fecha.Fecha,                                        
                                    }
                                );    
                            });                             
                        }                            
                        else
                            element.FechasDeEmision = null;
                        this.cedula.Acuerdos.push(element);
                    }
                });
                console.log(this.cedula.Acuerdos);
                this.cedula.Expediente = this.expediente;
                

                const peticion = { 
                    cedula: this.cedula
                }                                
               
                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.GuardarAcuerdosDeCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                    } else {
                        if(this.editar) {
                            this.$refs['FormEmpresaDomicilio'].domicilios = [];
                            this.$refs['FormEmpresaDomicilio'].domiciliosTabla = [];
                        }
                        
                        /* version estable 04/02/2022
                            this.obtenerCedula(); */

                        this.obtenerCedula({ conActivacionDePestana: false });
                        
                        //Para cambio de pestaña
                        $("#asignar-acuerdos-tab").removeClass('active');
                        $("#llenar-plantilla-tab").removeClass('disabled');
                        $("#llenar-plantilla-tab").trigger('click') ;                                                                                     
                    }
                    comun.SeEstaCargandoInformacion(false);
                    this.$nextTick(() => {
                        $('html, body').animate({ scrollTop:0 }, 'slow'); 
                    });
                })                
                .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }           
        },           
        formatoFechaAcuerdo: function(acuerdo){            
            /* let formatoFecha = acuerdo.FechaDePublicacion.split('T');
            if(acuerdo.FechaDePublicacion && formatoFecha.length > 1){                             
                acuerdo.FechaDePublicacion = moment(acuerdo.FechaDePublicacion).format("DD-MM-YYYY");                
            }  */
            if(acuerdo.FechaDePublicacion != null && acuerdo.FechaDePublicacion != undefined) {
                let formatoFecha = acuerdo.FechaDePublicacion.split('T');
                if(acuerdo.FechaDePublicacion && formatoFecha.length > 1){                             
                    acuerdo.FechaDePublicacion = moment(acuerdo.FechaDePublicacion).format("DD-MM-YYYY");                
                } 
            }
        },
        formatoFecha: function(fecha){         
            return moment(fecha).format("DD-MM-YYYY");                                        
        },
        obtenerNombreArchivoDeCedula: function(name) {
            if((this.cedula.ArchivoRuta != null && this.cedula.ArchivoRuta != "")) {
                const ruta_archivo = this.cedula.ArchivoRuta.split('\\');
                const nombre_archivo = ruta_archivo[ruta_archivo.length -1];
                this.nombreArchivoDeCedula =` ${nombre_archivo}`;
            }else if( name != undefined)
                this.nombreArchivoDeCedula = name;
        },
        crearArchivodeCedula: function(evento){        
            if(evento != undefined){
                comun.SeEstaCargandoInformacion(true);                                                
                var plantillaId = 0;   
                var conAcuerdos = false;             
                if(evento != undefined){
                    plantillaId = evento.plantillaObj.TipoPlantillaId;
                    this.cedula.Comentarios = evento.comentarios;   
                    conAcuerdos = evento.conAcuerdos;             
                }else{
                    plantillaId = this.cedula.Plantilla.tipoPlantillaId;
                }
                
                this.cedula.Acuerdos.forEach(element => { 
                    let acuerdo = this.expediente.Acuerdos.find(acuerdo => acuerdo.AcuerdoIdReferencia == element.AcuerdoIdReferencia);
                    element.FechaDePublicacion = acuerdo.FechaDePublicacion;                    
                });
                
                const peticion = { 
                    EsPrueba: this.enumeraciones.EsPrueba,
                    tipoPlantillaId:plantillaId,
                    cedula: this.cedula,
                    conAcuerdos: conAcuerdos,
                    anexosDeExpediente: evento.anexos,
                    numeroOrdenProteccion: this.numeroOrdenProteccion
                }                                
                
                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.CrearDocumentoDeCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                    } else {                         
                        this.creacionArchivo_index += 1;                                          
                        this.cedula.ArchivoRuta = respuesta.data.rutaArchivo;
                        //Cargar en visor   
                        this.parametros_SubidorDeArchivos.url = respuesta.data.rutaArchivo;                        
                        this.parametros_SubidorDeArchivos.key = "subidor_cedulaEditar" + respuesta.data.rutaArchivo + this.creacionArchivo_index;                                              
                    }   
                    comun.SeEstaCargandoInformacion(false);
                })                
                .catch(e => {
                    console.log("No Hay Respuesta del Servidor" + e);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
        },
        crearArchivodeResultado: function(evento){        
            if(evento != undefined){
                comun.SeEstaCargandoInformacion(true);                                                
                var plantillaId = 0;
                if(evento != undefined){
                    plantillaId = evento.TipoPlantillaId;
                }else{
                    plantillaId = this.cedula.Plantilla.tipoPlantillaId;
                }
                
                // if(this.cedula.Resultado == null){
                //     this.cedula.Resultado.ObservacionesResultado = this.observacionesResultadoCedula;
                //     this.cedula.Resultado.TipoResultado = { TipoResultadoId: enumeraciones.sinoj.tiposResultado.Realizada}
                // }
                const peticion = { 
                    EsPrueba: this.enumeraciones.EsPrueba,
                    tipoPlantillaId:plantillaId,
                    cedula: this.cedula
                }                                
                
                axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.CrearDocumentoResultadoDeCedula,
                    peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if (respuesta.data.SiHayError) {                                    
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        console.log(respuesta);
                    } else {                         
                        this.creacionArchivoResultado_index += 1;    
                        let t = this.cedula; 
                        if(this.cedula.Resultado == null){
                            this.cedula.Resultado = {
                                ArchivoResultado_Ruta: ""
                            };
                        }                                     
                        this.cedula.Resultado.ArchivoResultado_Ruta = respuesta.data.rutaArchivo;
                        //Cargar en visor   
                        this.parametros_SubidorDeArchivosResultado.url = respuesta.data.rutaArchivo;                        
                        this.parametros_SubidorDeArchivosResultado.key = "subidor_cedulaEditar" + respuesta.data.rutaArchivo + this.creacionArchivoResultado_index;                                              
                    }   
                    comun.SeEstaCargandoInformacion(false);
                })                
                .catch(e => {
                    console.log("No Hay Respuesta del Servidor" + e);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
        },
        descargarArchivoDeCedula: function(){
        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${respuesta.data.rutaArchivo}`
                        a.click(); 
        },
        limpiarVista: function(recargarVista = true){
            this.cedula = {
                Expediente: {
                    Juzgado: {
                        Nombre: null
                    },
                    TipoDocumento: {
                        Nombre: null
                    },
                    NumeroDeDocumento: null
                },
                TipoCedula: {
                    Nombre: null
                },
                Jurisdiccion: {
                    Area: { Nombre: null }
                },
                Urgente: null,
                Acuerdos: [],
                ArchivoRuta: null
            }       
            
            this.domicilioTmpNotificacionMultiple = null;         

            comun.SeEstaCargandoInformacion(true);
            if(recargarVista){
            if(!this.editar)
                this.$router.go()
            else
                Router.push({ name: 'ConsultaJuzgado' });
            }
        },
        regresarPestañas: function(){
            $("#datos-generales-cedula-tab").addClass('disabled');
            $("#llenar-plantilla-tab").addClass('disabled');
            $("#asignar-acuerdos-tab").addClass('disabled');
            $("#crear-cedula-tab").addClass('disabled');                        
            $("#resultado-cedula-tab").addClass('disabled');                        

            $("#busqueda-expediente-cedula-tab").addClass('active');
            $("#busqueda-expediente-cedula-tab").trigger('click');
        },
        obtenerArchivoResultado: function(evento){ 
            this.archivoResultadoCedula = evento;            
            this.obtenerNombreArchivoDeResultado(evento.name);
        },
        obtenerNombreArchivoDeResultado:function(name){   
            if((this.cedula.Resultado != null && this.cedula.Resultado.ArchivoResultado_Ruta != null && this.cedula.Resultado.ArchivoResultado_Ruta != "")) {
                const ruta_archivo = this.cedula.Resultado.ArchivoResultado_Ruta.split('\\');
                const nombre_archivo = ruta_archivo[ruta_archivo.length -1];
                this.nombreArchivoDeResultado =`${nombre_archivo}`;
            }else if( name != undefined)
                this.nombreArchivoDeResultado = name;
        },
        GuardarResultado: function (){
            
                comun.SeEstaCargandoInformacion(true);            
                let datosDelFormulario = new FormData();

                if(this.archivoResultadoCedula != null)
                    datosDelFormulario.append('Archivo', this.archivoResultadoCedula);
                datosDelFormulario.append('Observaciones', this.observacionesResultadoCedula);
                datosDelFormulario.append('CedulaId', this.cedula.CedulaId);                

                datosDelFormulario.append('EsPrueba', this.enumeraciones.EsPrueba);
                
                axios.post(
                    api.conexion + api.SINOJ.sistema.cedulas.creacion.GuardarDocumentoResultado,                
                    datosDelFormulario,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
                ).then(respuesta => {  
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                    } else { 
                        //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);                          
                        this.cedula.Resultado = respuesta.data.Resultado;                                

                        //Para cambio de pestañas
                        $("#resultado-cedula-tab").removeClass('active');
                        $("#crear-cedula-tab").removeClass('disabled');
                        $("#crear-cedula-tab").trigger('click')     
                        this.GuardarCedula();                
                    }
                    comun.SeEstaCargandoInformacion(false);
                    this.$nextTick(() => {
                        $('html, body').animate({ scrollTop:0 }, 'slow'); 
                    });
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);                
                }); 
            // }else{//Si no hay cambio de archivo
            //     //Para cambio de pestañas                                        
            //     $("#resultado-cedula-tab").removeClass('active');
            //     $("#crear-cedula-tab").removeClass('disabled');
            //     $("#crear-cedula-tab").trigger('click')
            // }        
        },
        EstablecerEstatus: function(){             
            if(this.seNotificaEnJuzgado == "true"){
                this.cedula.Estatus = { TipoEstatusId: enumeraciones.sinoj.tiposEstatus.finalizado }                 
                if(this.cedula.Resultado == null || this.cedula.Resultado.ResultadoId == undefined){  
                    this.cedula.Resultado = {};              
                    this.cedula.Resultado.ObservacionesResultado = this.observacionesResultadoCedula;
                    this.cedula.Resultado.TipoResultado = { TipoResultadoId: enumeraciones.sinoj.tiposResultado.Realizada}
                }             
            }
            else if(this.cedula.Expediente.Juzgado.AreaId == enumeraciones.sinoj.juzgadosMixtos.Calvillo || 
                    this.cedula.Expediente.Juzgado.AreaId == enumeraciones.sinoj.juzgadosMixtos.JesusMaria || 
                    this.cedula.Expediente.Juzgado.AreaId == enumeraciones.sinoj.juzgadosMixtos.Pabellon || 
                    this.cedula.Expediente.Juzgado.AreaId == enumeraciones.sinoj.juzgadosMixtos.RinconDeRomos){
                                
                let mismaJurisdiccion = this.parametros_Jurisdicciones.areasDeJurisdiccion.some(area => area.AreaId == this.cedula.Expediente.Juzgado.AreaId);
                this.parametros_TiposCedula.areasDeJurisdiccion
                if(mismaJurisdiccion){
                    this.cedula.Estatus = { TipoEstatusId: enumeraciones.sinoj.tiposEstatus.enviada }   
                    this.cedula.FechaDeEnvio = new Date();
                }else{                   
                    this.cedula.Estatus = { TipoEstatusId: enumeraciones.sinoj.tiposEstatus.creada }                       
                }
            }else{                
                this.cedula.Estatus = { TipoEstatusId: enumeraciones.sinoj.tiposEstatus.creada }
                }
        },
        aplicarProcesoDeAsignacionANotificador: function() {
            if(this.esJuzgadoMixto)
                this.asignacionDeNoificadorJuzgadoMixto();
        },
        asignacionDeNoificadorJuzgadoMixto: function() {
            const ES_PARA_OTRA_JURISDICCION = (this.cedula.Jurisdiccion.Area.AreaId != this.areaUsuarioJuzgado.AreaId);
            if(ES_PARA_OTRA_JURISDICCION)
                this.cedula.Notificador = null;
            else if(this.asignacionManualJuzgadosMixtos.aplicar)
                this.cedula.Notificador = this.asignacionManualJuzgadosMixtos.catalogoNotificadores.seleccionado;
        },
        GuardarCedula: function(){
            comun.SeEstaCargandoInformacion(true);            
                                      
            //this.$nextTick(() => {
                this.EstablecerEstatus();    
            //});            

            this.aplicarProcesoDeAsignacionANotificador();
            const peticion = { 
                Cedula : this.cedula,
                EsJuzgadoMixto: this.esJuzgadoMixto
            }                     
                                         
            axios.post(api.conexion + api.SINOJ.sistema.cedulas.creacion.GuardarCedula,
                peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {  
                if (respuesta.data.SiHayError) {                                    
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    console.log(respuesta);
                } else {                                                                                                
                    /* modificacion realizada 25/10/2021
                    this.limpiarVista();                           
                }
                comun.SeEstaCargandoInformacion(false); */
                    comun.SeEstaCargandoInformacion(false);                    
                    if(!this.editar)                       
                        manipularVisualizacionModal({ idModal: 'modal-informativo-expediente', mostrar: true });                        
                    else
                        this.limpiarVista();                    
                }
                this.$nextTick(() => {
                    $('html, body').animate({ scrollTop:0 }, 'slow'); 
                });       
            })            
            .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });                         
        },
        async obtenerEmpresas(persona) {  
            let personaMoral = persona.DatosGenerales.Moral;      
            
            // definimos metodo de API            
            let urlApi = api.conexion + api.SINOJ.catalogos.C007TiposEmpresas;
            // creamos la peticion con el formulario
            if(this.parametros == null || this.parametros == undefined)
                this.parametros = {};

            this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
            this.parametros.ConRepresentantesLegales = true;
            this.parametros.ConDomicilios = true;                        
                    
            // contruir header de la peticion            
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
            
            let data = axios.post(urlApi, this.parametros, headerPeticion)
                .then(async respuesta => {        
                    if (respuesta.data.SiHayError) {                        
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {    
                        this.conCatalogo = false;                                         
                        let empresa = respuesta.data.Empresas.find(element => element.Nombre == personaMoral.Nombre);
                        if(empresa != undefined){                                                                                 
                            this.parametros_Empresas.empresaId = empresa.EmpresaId;
                            /* this.parametros_Empresas.key = "empresa" + empresa.EmpresaId; */
                            empresa.Notificador = this.parametros_Empresas.notificador;
                            this.eventoCambioDeEmpresa('', empresa);
                            this.conCatalogo = true;                            
                        }                                                                                                 
                        
                        if(this.conCatalogo){
                            if(personaMoral.RepresentantesLegales.length > 0){
                                let representanteDB = personaMoral.RepresentantesLegales[0];
                                let representanteEditar = empresa.RepresentantesLegales.find(element =>
                                    element.DatosGenerales.Fisica != null &&
                                    element.DatosGenerales.Fisica.Nombre == representanteDB.DatosGenerales.Fisica.Nombre &&
                                    element.DatosGenerales.Fisica.ApellidoPaterno == representanteDB.DatosGenerales.Fisica.ApellidoPaterno &&
                                    element.DatosGenerales.Fisica.ApellidoMaterno == representanteDB.DatosGenerales.Fisica.ApellidoMaterno
                                );
                                if(representanteEditar != undefined && representanteEditar != null){  
                                    this.representanteLegal = true;                              
                                    this.parametros_RepresentantesLegales.personaId = representanteEditar.PersonaId;
                                    this.parametros_RepresentantesLegales.key = "representanteEditar_" + this.parametros_RepresentantesLegales.personaId;
                                
                                    if(persona.TipoPersonalidad != undefined){
                                        this.parametros_TipoPersonalidad.tipoPersonalidadId = persona.TipoPersonalidad.TipoPersonalidadId;
                                        this.parametros_TipoPersonalidad.key = "representanteEditar_" + this.parametros_TipoPersonalidad.tipoPersonalidadId;
                                    }
                                }
                                else{ 
                                    this.representanteLegal = false; 
                                    this.representanteUniversal = representanteDB.DatosGenerales.Fisica.Nombre;
                                }
                            }
                        }else{
                            this.parametros_personaMoral.persona = persona;
                            this.parametros_personaMoral.key = "empresaEditar_" + personaMoral.MoralId;
                            this.conFormulario = true;                            
                        }                                                                      
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
            )    
            return data;    
        },
        async cargarDatosDeCedulaAEditar ({ conActivacionDePestana = true }){  
            //Búsqueda de expediente            
            if(this.cedula.Expediente != undefined){  
                this.tipoDocumentoId = this.cedula.Expediente.TipoDocumento.TipoDocumentoId; 
                this.filtrosEstablecidos = {
                    MateriaId: this.cedula.Expediente.Materia.MateriaId,
                    AreaId: this.cedula.Expediente.Juzgado.AreaId,
                    TipoDocumentoId: this.cedula.Expediente.TipoDocumento.TipoDocumentoId,
                    Consecutivo: this.cedula.Expediente.NumeroDeDocumento
                }
                
                if(this.cedula.Expediente.TipoDocumento.TipoDocumentoId == 2 || this.cedula.Expediente.TipoDocumento.TipoDocumentoId == 10){
                    this.filtrosEstablecidos.NumeroExtra = this.cedula.Expediente.Consecutivo;                                      
                }
                                
                this.filtrosKey = "Edicion_" + this.filtrosEstablecidos.MateriaId + this.filtrosEstablecidos.AreaId + this.filtrosEstablecidos.TipoDocumentoId + this.filtrosEstablecidos.Consecutivo;
                                
                this.$store.dispatch('A_PJ_Catalogo_Establecer002Materia', { llave: 'filtro-materia-creacionCedula', valor: this.cedula.Expediente.Materia.MateriaId });
                this.$store.dispatch('A_PJ_Catalogo_Establecer001Area', { llave: 'filtro-area-creacionCedula', valor: this.cedula.Expediente.Juzgado.AreaId });
                this.$store.dispatch('A_PJ_Catalogo_Establecer004TipoDocumento', { llave: 'filtro-tipoDocumento-creacionCedula', valor: this.cedula.Expediente.TipoDocumento.TipoDocumentoId });
                this.$store.dispatch('A_Comun_Consecutivo', this.cedula.Expediente.NumeroDeDocumento );
                this.$store.dispatch('A_Comun_NumeroExtra', this.cedula.Expediente.Consecutivo );                 

                await this.buscarExpediente(conActivacionDePestana).then((result) => {                   
                    let _this = this;                    

                    //Se activa pestaña de datos generales                
                    $("#datos-generales-cedula-tab").removeClass('disabled');
                    
                    //Se asigna id de expediente
                    this.expediente.ExpedienteId = this.cedula.Expediente.ExpedienteId;                                      
                    
                    //Persona a notificar                   
                    if(this.cedula.PersonasANotificar.length > 0){       
                        let domicilios = [];
                        
                        this.cedula.PersonasANotificar.forEach(persona => {                                                    
                        switch(persona.TipoPersona.TipoPersonaId){
                            case 2://Persona Fisica                                                                                            
                                let parteFisicaExpediente = this.expediente.Personas.filter(element => 
                                    element.DatosGenerales.Fisica != null &&
                                    element.DatosGenerales.Fisica.Nombre == persona.DatosGenerales.Fisica.Nombre &&
                                    element.DatosGenerales.Fisica.ApellidoPaterno == persona.DatosGenerales.Fisica.ApellidoPaterno &&
                                    element.DatosGenerales.Fisica.ApellidoMaterno == persona.DatosGenerales.Fisica.ApellidoMaterno
                                );

                                //Si es parte
                                if(parteFisicaExpediente != undefined && parteFisicaExpediente != null && parteFisicaExpediente.length > 0){
                                    this.tipoDePersona = '3';  

                                    /* anterior
                                    this.parteANotificar = {
                                            idCheck: 'tabla-partes-check-' + parteFisicaExpediente[0].PersonaIdDeReferencia,
                                            id: parteFisicaExpediente[0].PersonaIdDeReferencia,
                                            seleccionado: true
                                        }   
                                     */
                                    // se seleccionan  las partes en el caso de estrados
                                    const ES_POR_ESTRADOS = (this.cedula.SeNotificaEnJuzgado && this.cedula.EsDeEstrado);
                                    let partesSeleccionadas = [];
                                    if(ES_POR_ESTRADOS) {
                                        this.personasANotificar = parteFisicaExpediente;
                                        partesSeleccionadas = parteFisicaExpediente.map(pBD => {
                                            let persona = {
                                                idCheck: 'tabla-partes-check-' + pBD.PersonaIdDeReferencia,
                                                id: pBD.PersonaIdDeReferencia,
                                                seleccionado: true
                                            }
                                            return persona;
                                        });
                                        console.log('ES_POR_ESTRADOS::',partesSeleccionadas);
                                    }
                                    else {
                                        this.parteANotificar = {
                                            idCheck: 'tabla-partes-check-' + parteFisicaExpediente[0].PersonaIdDeReferencia,
                                            id: parteFisicaExpediente[0].PersonaIdDeReferencia,
                                            seleccionado: true
                                        }   
                                        console.log('NO_ES::ES_POR_ESTRADOS::',this.parteANotificar);   
                                    }

                                    //Se selecciona parte
                                    this.mostrarEstadoCheckbox(partesSeleccionadas);                                    
                                }else{  //Es persona física     
                                    this.tipoDePersona = '1';                                                                                    
                                    this.personaFisica.nombre = persona.DatosGenerales.Fisica.Nombre;
                                    this.personaFisica.apellidoMaterno = persona.DatosGenerales.Fisica.ApellidoPaterno;
                                    this.personaFisica.apellidoPaterno= persona.DatosGenerales.Fisica.ApellidoMaterno;
                                    
                                    this.parametros_TipoPersonalidad.tipoPersonalidadId = persona.TipoPersonalidad.TipoPersonalidadId;                                    
                                }

                                this.personaANotificar = persona;

                                //Se muestran direcciones
                                domicilios = persona.Domicilios;
                                
                                if(domicilios.length > 0) {
                                    const CON_MENSAJE_DE_DOMICILIOS = false;
                                    this.$refs['FormEmpresaDomicilio'].cargarDomiciliosGuardados(domicilios, CON_MENSAJE_DE_DOMICILIOS);
                                }

                                this.listaDeDomicilios = [];
                                persona.Domicilios.forEach(element => {
                                    let agregar = {
                                         Domicilio: element
                                    }
                                    this.listaDeDomicilios.push(agregar);
                                });   
                                this.$nextTick(() => {
                                    this.$refs['FormEmpresaDomicilio'].seleccionarElementoEnTabla();
                                });                                                                                         
                            break;
                            case 3: //Persona Moral
                                this.tipoDePersona = '2'; 
                                
                                //Si es parte
                                let parteMoralExpediente = this.expediente.Personas.filter(element => 
                                    element.DatosGenerales.Moral != null &&
                                    element.DatosGenerales.Moral.Nombre == persona.DatosGenerales.Moral.Nombre                                    
                                );

                                if(parteMoralExpediente != undefined && parteMoralExpediente != null && parteMoralExpediente.length > 0){
                                    this.tipoDePersona = '3';

                                    const ES_POR_ESTRADOS = (this.cedula.SeNotificaEnJuzgado && this.cedula.EsDeEstrado);
                                    let partesSeleccionadas = [];
                                    if(ES_POR_ESTRADOS) {
                                        this.personasANotificar = parteMoralExpediente;
                                        partesSeleccionadas = parteMoralExpediente.map(pBD => {
                                            let persona = {
                                                idCheck: 'tabla-partes-check-' + pBD.PersonaIdDeReferencia,
                                                id: pBD.PersonaIdDeReferencia,
                                                seleccionado: true
                                            }
                                            return persona;
                                        });
                                        console.log('ES_POR_ESTRADOS::',partesSeleccionadas);
                                    }
                                    else {
                                        this.personaANotificar = persona;
                                        this.parteANotificar = {
                                                    idCheck: 'tabla-partes-check-' + parteMoralExpediente[0].PersonaIdDeReferencia,
                                                    id: parteMoralExpediente[0].PersonaIdDeReferencia,
                                                    seleccionado: true
                                                }      
                                                domicilios = persona.Domicilios;
                                        
                                        if(domicilios.length > 0) {
                                            const CON_MENSAJE_DE_DOMICILIOS = false;
                                            this.$refs['FormEmpresaDomicilio'].cargarDomiciliosGuardados(domicilios, CON_MENSAJE_DE_DOMICILIOS);
                                        }

                                        this.listaDeDomicilios = [];
                                        persona.Domicilios.forEach(element => {
                                            let agregar = {
                                                Domicilio: element
                                            }
                                            this.listaDeDomicilios.push(agregar);
                                        });   
                                        this.$nextTick(() => {
                                            this.$refs['FormEmpresaDomicilio'].seleccionarElementoEnTabla();
                                        });           
                                    }
                                    console.log('NO_ES::ES_POR_ESTRADOS::',this.parteANotificar);   
                                    //Se selecciona parte
                                    this.mostrarEstadoCheckbox(partesSeleccionadas);  
                                }else{
                                    this.obtenerEmpresas(persona).then(()=> {                                
                                        //Se muestran direcciones                                       
                                        this.personaANotificar = persona;  
                                        if(this.conCatalogo){                                        
                                            this.parametros_RepresentantesLegales.representantesLegales =  persona.DatosGenerales.Moral.RepresentantesLegales;                                          
                                        }             
                                        
                                        // INICIO ################ cambios realizados 04/02/2022
                                        // Motivo: cuando se edita una persona moral fura del formulario no se muestra el domicilio
                                        //Se muestran direcciones
                                        domicilios = persona.Domicilios;
                                        
                                        if(domicilios.length > 0) {
                                            const CON_MENSAJE_DE_DOMICILIOS = false;
                                            this.$refs['FormEmpresaDomicilio'].cargarDomiciliosGuardados(domicilios, CON_MENSAJE_DE_DOMICILIOS);
                                        }

                                        this.listaDeDomicilios = [];
                                        persona.Domicilios.forEach(element => {
                                            let agregar = {
                                                Domicilio: element
                                            }
                                            this.listaDeDomicilios.push(agregar);
                                        });   
                                        this.$nextTick(() => {
                                            this.$refs['FormEmpresaDomicilio'].seleccionarElementoEnTabla();
                                            this.$refs['registroAltaEmpresaForm'].guardarPersonaMoral({ evento: null, conMensaje: false });
                                        });  
                                        // FIN ################ cambios realizados 04/02/2022       
                                    })
                                }                                                                 
                            break;
                        }
                        });
                        
                    }

                    //Activar pestaña                                                  
                    $("#llenar-plantilla-tab").removeClass('disabled');      

                    //Datos generales
                    if(this.cedula.Jurisdiccion != undefined){
                        this.parametros_Jurisdicciones.jurisdiccionId = this.cedula.Jurisdiccion.JurisdiccionId;
                        this.parametros_Jurisdicciones.key = "cedulaEditar_" + this.parametros_Jurisdicciones.jurisdiccionId;
                    }
                    
                    if(this.cedula.TipoCedula != undefined){                        
                        this.parametros_TiposCedula.tipoCedulaId = this.cedula.TipoCedula.TipoCedulaId;                        
                        this.parametros_TiposCedula.key = "cedulaEditar_" + this.parametros_TiposCedula.tipoCedulaId;

                        //Actualizamos parámetros del subidor
                        this.parametros_SubidorDeArchivos.tipoCedulaId =this.cedula.TipoCedula.TipoCedulaId;  
                        this.parametros_SubidorDeArchivos.key = "subidor_tipoCedula" + this.cedula.TipoCedula.TipoCedulaId;
                    }
                           
                    if(this.cedula.Notificador != undefined)  {
                        this.parametros_Empresas.notificador = this.cedula.Notificador                        
                    }          
                        
                    if(this.cedula.EsOrdenDeProteccion != undefined){
                        this.esOrdenDeProteccion = this.cedula.EsOrdenDeProteccion;
                    } 

                    if(this.cedula.Urgente != undefined){                        
                        if(this.cedula.Urgente)
                            this.esUrgente = true;
                        else
                            this.esUrgente = false;
                    }
                    
                    if(this.cedula.TipoAudiencia != undefined && this.cedula.TipoAudiencia.TipoAudienciaId != null){
                        this.parametros_TipoAudiencia.TipoAudienciaId = this.cedula.TipoAudiencia.TipoAudienciaId;
                        this.parametros_TipoAudiencia.key = "editarCedula_" + this.cedula.TipoAudiencia.TipoAudienciaId;                        
                    }

                    if(this.cedula.FechaDeDictadoDeSentencia != undefined){
                        this.cedula.FechaDeDictadoDeSentencia = moment(this.cedula.FechaDeDictadoDeSentencia).format('YYYY-MM-DD');
                    }
                        
                    //Cargar archivo de cédula
                    //Actualizamos parámetros del subidor
                    if(this.cedula.ArchivoRuta != null){                        
                        this.parametros_SubidorDeArchivos.areaId = this.cedula.Expediente.Juzgado.AreaId;
                        this.parametros_SubidorDeArchivos.tipoCedulaId = this.cedula.TipoCedula.TipoCedulaId;                                        
                        this.parametros_SubidorDeArchivos.url = this.cedula.ArchivoRuta;                  
                        this.parametros_SubidorDeArchivos.key = "subidor_cedulaEditar" + this.cedula.TipoCedula.TipoCedulaId;            
                    }
            
                    //Acuerdos
                    if(this.cedula.Acuerdos.length > 0){ 
                        //Activar pestaña                
                        $("#asignar-acuerdos-tab").removeClass('disabled');   
                
                        this.cedula.Acuerdos.forEach(element => {
                            let acuerdo = {
                                Folio: element.AcuerdoIdReferencia,
                                Extracto: element.Extracto,
                                FechaDePublicacion: moment(element.FechaDePublicacion).format("DD-MM-YYYY")
                            }

                            this.parametros_listaDeAcuerdos.listaDeAcuerdosSelect.push(acuerdo);                    
                        });
                        
                        this.contadorFechasEmision = 0;
                        this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados = this.cedula.Acuerdos;      
                        console.log(this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados);                         
                        this.parametros_listaDeAcuerdos.listaDeAcuerdosSeleccionados.forEach(element => {      
                            console.log("antes " + element.FechaDeAudiencia);                                  
                            //element.FechaDeAudiencia = moment(element.FechaDeAudiencia).format('DD-MM-YYYY HH:MM:SS');  //'YYYY-MM-DD'      
                            console.log("despues " + element.FechaDeAudiencia); 
                            element.FechasDeEmision.forEach(fechaEmision => { 
                                this.FechasDeEmision.push({
                                    ReferenciaId: this.contadorFechasEmision,                                    
                                    Fecha: moment(fechaEmision.Fecha).format('YYYY-MM-DD'),
                                    Acuerdo: element
                                });                
                            });  
                            let r = this.FechasDeEmision;
                            console.log(this.FechasDeEmision);                          
                        });
                
                        this.parametros_listaDeAcuerdos.key = "acuerdos_cedulaEditar" + this.cedula.CedulaId;
                        this.parametros_listaDeAcuerdos.acuerdoPrincipal = this.cedula.Acuerdos.find(element => element.EsPrincipal).AcuerdoIdReferencia;
                        this.parametros_listaDeAcuerdos.numeroDeAcuerdosSeleccionados = this.cedula.Acuerdos.length;
                    }                        
                    
                    //Resultado
                    if(this.cedula.Resultado != null && this.cedula.SeNotificaEnJuzgado)
                    {                                                
                        this.seNotificaEnJuzgado = 'true'; 
                        this.esEstrado = this.cedula.EsDeEstrado;
                        if(this.esEstrado != null && this.esEstrado != undefined) {
                            this.esEstrado = this.esEstrado.toString();
                        }
                                           
                        //Activar pestaña                
                        $("#resultado-cedula-tab").removeClass('disabled');
                        $("#resultado-cedula-tab").addClass('active');  
                        this.$nextTick(() => {        
                            if(this.seNotificaEnJuzgado){                                                              
                                $("#resultado-cedula-tab").removeClass('disabled');                                                                
                            } 
                        });
                                                
                        if(this.cedula.Resultado.ObservacionesResultado != null)
                            this.observacionesResultadoCedula = this.cedula.Resultado.ObservacionesResultado;
                        else
                            this.observacionesResultadoCedula = '';
                        
                        this.parametros_SubidorDeArchivosResultado.areaId = this.cedula.Expediente.Juzgado.AreaId;
                        this.parametros_SubidorDeArchivosResultado.tipoCedulaId = this.cedula.TipoCedula.TipoCedulaId;
                        this.parametros_SubidorDeArchivosResultado.tipoResultadoId = enumeraciones.sinoj.tiposResultado.Realizada;         
                        this.parametros_SubidorDeArchivosResultado.url = this.cedula.Resultado.ArchivoResultado_Ruta;                        
                        this.parametros_SubidorDeArchivosResultado.key = "subidor_cedulaEditarResultado" + this.cedula.TipoCedula.TipoCedulaId;            
                        
                        this.obtenerNombreArchivoDeResultado();                     
                    }   
                    else if(this.cedula.SeNotificaEnJuzgado) {
                        this.seNotificaEnJuzgado = 'true'; 
                        this.esEstrado = this.cedula.EsDeEstrado;
                        if(this.esEstrado != null && this.esEstrado != undefined) {
                            this.esEstrado = this.esEstrado.toString();
                        }
                    }                                                                                  

                    if(!$("#asignar-acuerdos-tab").hasClass('disabled')){
                        //Activar pestaña
                        $("#crear-cedula-tab").removeClass('disabled');
                    } 
                });  
                               
            }                                                           
        },
        seleccionarTodasPartes: function(evento){             
            if(evento.target.checked)
                this.personasANotificar = this.expediente.Personas;        
            else
                this.personasANotificar = [];

            this.$nextTick(() => {
                this.seleccionarTodosCheckboxPartes(evento);
            });            
        },
        seleccionarTodosCheckboxPartes: function (evento) {
            let seleccionar = evento.target.checked;
            this.expediente.Personas.forEach((parte) => {
              $("#tabla-partes-check-" + parte.PersonaIdDeReferencia).prop('checked', seleccionar);
            });            
        },
        agregarParteSeleccionada: function(evento, parte) {            
            if(evento.target.checked)
                this.personasANotificar.push(parte);
            else
                this.personasANotificar = this.personasANotificar.filter(persona => persona.PersonaIdDeReferencia != parte.PersonaIdDeReferencia);
        },
        eliminarPersonaANotificar: function (evento, parte){            
            $("#tabla-partes-check-" + parte.PersonaIdDeReferencia).prop('checked', false);
            this.personasANotificar = this.personasANotificar.filter(persona => persona.PersonaIdDeReferencia != parte.PersonaIdDeReferencia);
        },
       /* funcion encargada de mostrar los input check habilitados en base al renderizad de la paginacion de la tabla.*/       
       mostrarEstadoCheckbox: function (partesCasoEstrados = null) {           
            this.$nextTick(() => { //debugger
                $("#tablaCedulas input[type='checkbox']").prop('checked', false); 
                if(partesCasoEstrados == null || partesCasoEstrados == undefined || partesCasoEstrados.length < 1)       
                    $("#" + this.parteANotificar.idCheck).prop('checked', this.parteANotificar.seleccionado);
                else if(partesCasoEstrados != null && partesCasoEstrados.length > 0) {
                    partesCasoEstrados.forEach(pN => {
                        $("#" + pN.idCheck).prop('checked', pN.seleccionado);
                    });
                }
            });        
      },      
      /* funcion encargada de realizar el desplazamiento con las opciones de siguiente o anterior.
      * @param {object} evento [evento click opcion(siguiente o anterior)]*/      
      cambioDePaginaConOpcion: function (evento) {
        const SELECCION_ID = evento.target.getAttribute('id');
        const ANTERIOR_ID = 'opcionInicio';
        const SIGUIENTE_ID = 'opcionSiguiente';

        if (SELECCION_ID === ANTERIOR_ID) {
          this.pagina--;
        }
        else if (SELECCION_ID === SIGUIENTE_ID) {
          this.pagina++;
        }
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          $("#" + 'paginacion-tabla-partes-creacionCedula ' + "li").removeClass('active');
          $("#" + 'tabla-partes-creacionCedula'+ 'pagina' + this.pagina).addClass('active');
        });
      },
      eventoParteSeleccionada: function(evento, parte) {
          const seleccionId = evento.target.getAttribute('id');
          const parteId = seleccionId.split("-");
          const seleccion = $('#' + seleccionId).is(":checked");

          this.parteANotificar = {
            idCheck: seleccionId,
            id: parteId[parteId.length -1],
            seleccionado: seleccion
          }
          
          this.personaANotificar = parte;
          this.mostrarEstadoCheckbox();
      },
      /**
      * funcion encargada de realizar el desplazamiento mediante click directo sobre el numero de pagina.
      * @param {object} numeroDePagina [valor de pagina para realizar la paginacion]
      */
      cambioDePaginaConPuntero: function (numeroDePagina) {
        this.pagina = numeroDePagina;
        this.$nextTick(() => {
           this.mostrarEstadoCheckbox();
          $("#" + 'paginacion-tabla-partes-creacionCedula ' + "li").removeClass('active');
          $("#" + 'tabla-partes-creacionCedula'+ 'pagina' + this.pagina).addClass('active');
        });
      },
      /**
      * funcion encargada de obtener el numero de paginas en base a una fuente de datos dividido entre
      * el numero de registros que se desea mostrar por paginacion en la tabla.
      * @see {@link listaDeCedulas}
      * @see {@link cedulasAmostrarPorPagina}
      */
      obtenerNumeroDePaginas: function () {
        let numeroDePaginas = Math.ceil(this.expediente.Personas.length / this.partesAmostrarPorPagina);
        this.numeroDePaginas = [];
        this.pagina = 1;
        this.parteANotificar = {};
        for (let i = 1; i <= numeroDePaginas; i++) {
          this.numeroDePaginas.push(i);
        }
        this.$nextTick(() => {
          $("#" + 'paginacion-tabla-partes-creacionCedula ' + "li").removeClass('active');
          $("#" + 'tabla-partes-creacionCedula'+ 'pagina' + this.pagina).addClass('active');
        });
        this.mostrarEstadoCheckbox();
      },
      contenidoColumnasTablaPartes: function(parte) { 
        let nombre;
        let contenido = [];

        /*  INICIO
            modiifcacion realizada 22/10/2021 
            motivo: cuando la parte no tiene un tipo de persona de deja como persona fisica
            Referencia: Persona.cs en constructor linea 287
         */
        if(parte.TipoPersona == null || parte.TipoPersona == undefined) {
            console.log('entro')
            parte.TipoPersona = { TipoPersonaId: enumeraciones.pj.tiposPersonas.Fisica, Nombre: 'Física' }
        }
            
        /* FIN */

        switch(parte.TipoPersona.TipoPersonaId){
          case enumeraciones.pj.tiposPersonas.Fisica:
            nombre = parte.DatosGenerales.Fisica.Nombre + " " + parte.DatosGenerales.Fisica.ApellidoPaterno + " " + parte.DatosGenerales.Fisica.ApellidoMaterno;
            break;
          case enumeraciones.pj.tiposPersonas.Moral:
            nombre = parte.DatosGenerales.Moral.Nombre;
            break;
        }         

          contenido.push(nombre);
          contenido.push(parte.TipoPersona.Nombre);
          contenido.push(parte.TipoPersonalidad.Nombre);

          return contenido;
      },
      paginacionDePartes: function(partes) {
        let pagina = this.pagina;
        let partesAmostrarPorPagina = this.partesAmostrarPorPagina;
        let desde = (pagina * partesAmostrarPorPagina) - partesAmostrarPorPagina;
        let hasta = (pagina * partesAmostrarPorPagina);
        return partes.slice(desde, hasta);
      }
    },
    watch: {
      partes() {
        this.obtenerNumeroDePaginas();
      }
    },   
     
}
</script>
<style scoped>
    #encabezados-tp {
        margin-bottom: 1em;
    }

    #encabezados-tp h1 {
        margin-bottom: 0;
        font-weight: bold;
    }

    #encabezados-tp h4 {
        font-size: 1.5em;
        color: rgb(214, 214, 214);
    }

    .hr-titulo {
        height:0.5em;
        width: 6em;
        border:none;
        background-color: var(--verde-pj-100);
    }
    #pasos-creacion-cedula .card-header {
        background-color: rgb(70, 70, 70);
    }

    #pasos-creacion-cedula .card-body {
        background-color: rgb(43, 43, 43);
    }

    #pasos-creacion-cedula .card {
        border: 1px solid rgb(107, 107, 107) !important;
    }
    #modal-informativo-dom .modal-lg {
        max-width: 30% !important;
    }

    #modal-informativo-dom .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    #modal-informativo-dom .modal-dialog {
        position: relative;
        top: 40%;
        transform: translateY(-50%);
    }

    #modal-informativo-expediente .modal-lg {
        max-width: 30% !important;
    }

    #modal-informativo-expediente .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    #modal-informativo-expediente .modal-dialog {
        position: relative;
        top: 40%;
        transform: translateY(-50%);
    }

    .deshabilitarSeccion {
        pointer-events:none;
        cursor: not-allowed;
        opacity: 0.5;
    }

    .asignacion-manual-estatus {
        border: 1px solid black;
        padding: 1em 0 1em 0;
        margin-left: 3em;
        position: relative;
        background-color: rgb(46, 46, 46);
        color: rgb(250, 245, 245);
    }

    #contendor-formulario-creacionDeCedula {
        display: flex;
        justify-content: center;
    }

    .contenedor-editorDeTexto {
        border: 3px solid #5c5959; 
        box-shadow: 0px 6px 20px 8px #0e0d0d;
    }   

    .contenedor-color-negro {        
        /* background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616; */
        padding: 25px
    }

    .contenedor-color-gris {
        border: 1px solid rgba(143,142,142,0.75);
        box-shadow: -6px 7px 5px 0px rgba(143,142,142,0.75);
    }

    .contenedor-color-negro-info {
        padding: 1em;
        /* background-color: #2c2d31;
        border: 2px solid #5c5959 */
    }

    .fila-formulario-horizontal {
        display: flex; 
        /* align-items: center;
        justify-content: center; */
    }

    .nav_tab_formularios {        
        padding: 25px;
        /* background-color: #323335;
        box-shadow: 0px 6px 20px 4px #161616; */
        background-color: var(--gris-pj-100);
    }
    .nav-tabs
    {
        border-bottom: 1px solid var(--gris-pj-100);
    }

    .nav-item>a.active, 
    .nav-item>a.active:focus, 
    .nav-item>a.active:hover {
        background-color: #323335;
        color: white;
        border-bottom: 1px solid #323335;
    }
    .nav-item>a{
        border-bottom: 1px solid white;
    } 

    .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
        color: white;
        background-color: #57585B;
        border-color: white;
    }
    .btn-secondary {
        color: rgb(106, 108, 112);
        background-color: #323335;
        border-color: rgb(106, 108, 112);
        font-size: 0.95rem;
    }
    .btn-secondary:hover {
        color: white;
        background-color: #323335;
        border-color: white;
    }

    #estatus-busqueda-expediente {
        background-color: var(--gris-pj-100);
        border: 1px solid var(--gris-pj);
        height: 5em;
        margin-top: 1em;
        padding: 1em;
        border-radius: 8px;
    }

    #titulo-tabla {
        /* background-color: #1b1919; */
        margin-top:2em;
        padding: 10px;
        margin-bottom: 0px;
        display: flex;
        justify-content: center;
    }
    .encabezados-listado {
        position: sticky;
        top: 0;
        background: #5c5959;
        border: 1;
    }

    .pagination > li > button:focus {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > .active > button {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagina-seleccionada {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > li > button {
    color: white;
    background-color: grey;
    border-color: black;
  }

    .pagination > li > button[id^="opcion"] {
        color: white;
        background-color: #26272b;
        border-color: black;
    }

    .pagination {
        margin: 0px !important;
    }

    .nav-item {
        background-color: #4b4c4e;
    }

    .nav-link {
        color: #ffff !important;
    }

    #contendor-principal-creacionCedula  .nav-link.active {
        background-color: var(--verde-pj-100) !important;
    }

    #contendor-principal-creacionCedula  .nav-link {
        background-color: var(--verde-pj) !important;
    }

    #contendor-principal-creacionCedula  .nav-link {
        color: #ffff !important;
    }

    /* .nav-item>a.active, 
    .nav-item>a.active:focus, 
    .nav-item>a.active:hover {
        background-color: var(--verde-pj-100);
        color: white;
        border-bottom: 1px solid #323335;
    }
    .nav-item>a{
        border-bottom: 1px solid white;
    } */

    
#contenedor-mapa {
    height: 410px;
    width: 80%;
    margin-left: 1em;
}

.acciones-mapa-domicilios {
    background-color: #323335;
    padding: 10px;
    width: 20%;
    border: 3px solid #272729;
}

#tablaPersonas td {
    color: white;
}

#personasANotificar_table td {
    color: white;
}

.btn-xs {
    color: white;
    background-color: rgb(32, 31, 31);
    border-color: white;
    width: 100%;
    height: 40px;
    cursor: pointer;
}

#lista-acuerdos-seleccionados td {
    color: white;
    position:relative;
}

.contenedor-ver-direccionCompleta {
    color: white;
    background-color: rgb(32, 31, 31);
    border-color: white;
    width: 100%;
    height: 100px;
    margin-top: 30%;
    padding: 1em;
    border: 1px solid white;
} 

#acuerdosSeleccionados_div th{
  width: 130px;
  overflow: auto;
}

#contendor-principal-creacionCedula .card-header {
    background-color: var(--verde-pj);
}

#contendor-principal-creacionCedula .card-body {
    background-color: var(--gris-pj-100);
}

#contendor-principal-creacionCedula .card-body h6 {
    color: black !important;
}

#tablaPersonas thead th,
#lista-acuerdos-seleccionados thead th {
    background-color: var(--verde-pj-100) !important;
}

#tablaPersonas tbody td {
    background-color: #ffff !important;
    color: black;
    border-color: #a7a7a7 !important;;
}

#lista-acuerdos-seleccionados tbody td {
    background-color: #bebebe;
    color: black;
}

/* #tablaPersonas tbody tr {
    border-bottom: #a7a7a7 !important;
} */

#contendor-principal-creacionCedula .form-control {
    background-color: white !important;
    color: black !important;
}

#contendor-principal-creacionCedula .modal-header {
    background-color: var(--verde-pj);
}

#contendor-principal-creacionCedula .modal-body {
    background-color: var(--gris-pj-100);
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/Creacion/CCreacionDeCedula.vue